import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { API } from 'aws-amplify';
import swal from '@sweetalert/with-react';
import { icon as fontawesomeIcon } from '@fortawesome/fontawesome-svg-core';
import { useOutsideClick, getData } from '../../../js/Helpers';
import { FileUpload } from '../../../js/upload';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faTimes, faSlidersH, faCheckSquare, faChevronUp, faChevronDown, faEllipsisV, faCheckCircle, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import Button from '../../Button';
import Dropdown from '../../Dropdown';
import LabelColorPicker from '../../hsms/common/LabelColorPicker';

import '../../../css/magnetboard.css';
import '../../../css/elementary/manage_homerooms.css';
import '../../../css/elementary/auto_scheduling_setup.css';

const DEFAULT_TEACHER_TAG_COLOR = 'bright-blue';
const ALL_TEACHER_TAG_COLOR_OPTIONS = [
	{value:'red', display:'Red'},
	{value:'bright-red', display:'Bright Red'},
	{value:'orange', display:'Orange'},
	{value:'dark-orange', display:'Dark Orange'},
	{value:'yellow', display:'Yellow'},
	{value:'bright-yellow', display:'Bright Yellow'},
	{value:'green', display:'Green'},
	{value:'bright-green', display:'Bright Green'},
	{value:'turquoise', display:'Turquoise'},
	{value:'blue', display:'Blue'},
	{value:'bright-blue', display:'Bright Blue'},
	{value:'dark-blue', display:'Dark Blue'},
	{value:'dark-blue-gray', display:'Dark Blue Gray'},
	{value:'pastel-dark-blue-gray', display:'Pastel Dark Blue Gray'},
	{value:'purple', display:'Purple'},
	{value:'bright-purple', display:'Bright Purple'},
	{value:'pastel-light-green', display:'Pastel Light Green'},
	{value:'pastel-green', display:'Pastel Green'},
	{value:'pastel-light-turquoise', display:'Pastel Light Turquoise'},
	{value:'pastel-turquoise', display:'Pastel Turquoise'},
	{value:'pastel-light-blue', display:'Pastel Light Blue'},
	{value:'pastel-blue', display:'Pastel Blue'},
	{value:'pastel-light-purple', display:'Pastel Light Purple'},
	{value:'dark-purple', display:'Dark Purple'},
	{value:'dark-purple-gray', display:'Dark Purple Gray'},
	{value:'pastel-dark-purple', display:'Pastel Dark Purple'},
	{value:'pastel-light-yellow', display:'Pastel Light Yellow'},
	{value:'pastel-yellow', display:'Pastel Yellow'},
	{value:'pastel-light-orange', display:'Pastel Light Orange'},
	{value:'pastel-orange', display:'Pastel Orange'},
	{value:'pastel-brown', display:'Pastel Brown'},
	{value:'dark-brown', display:'Dark Brown'},
	{value:'light-gray', display:'Light Gray'},
	{value:'gray', display:'Gray'},
	{value:'dark-gray', display:'Dark Gray'},
	{value:'white', display:'White'},
	{value:'elem-tag-cool-01', display:'Elem Cool 01'},
	{value:'elem-tag-cool-02', display:'Elem Cool 02'},
	{value:'elem-tag-cool-03', display:'Elem Cool 03'},
	{value:'elem-tag-cool-04', display:'Elem Cool 04'},
	{value:'elem-tag-cool-05', display:'Elem Cool 05'},
	{value:'elem-tag-cool-06', display:'Elem Cool 06'},
	{value:'elem-tag-cool-07', display:'Elem Cool 07'},
	{value:'elem-tag-cool-08', display:'Elem Cool 08'},
	{value:'elem-tag-cool-09', display:'Elem Cool 09'},
	{value:'elem-tag-cool-10', display:'Elem Cool 10'},
	{value:'elem-tag-cool-11', display:'Elem Cool 11'},
	{value:'elem-tag-cool-12', display:'Elem Cool 12'},
	{value:'elem-tag-cool-13', display:'Elem Cool 13'},
	{value:'elem-tag-cool-14', display:'Elem Cool 14'},
	{value:'elem-tag-cool-15', display:'Elem Cool 15'},
	{value:'elem-tag-cool-16', display:'Elem Cool 16'},
	{value:'elem-tag-cool-17', display:'Elem Cool 17'},
	{value:'elem-tag-cool-18', display:'Elem Cool 18'},
	{value:'elem-tag-cool-19', display:'Elem Cool 19'},
	{value:'elem-tag-cool-20', display:'Elem Cool 20'},
	{value:'elem-tag-cool-21', display:'Elem Cool 21'},
	{value:'elem-tag-cool-22', display:'Elem Cool 22'},
	{value:'elem-tag-cool-23', display:'Elem Cool 23'},
	{value:'elem-tag-cool-24', display:'Elem Cool 24'}
];

const TEACHER_TAG_COLOR_OPTION_MAP = new Map(ALL_TEACHER_TAG_COLOR_OPTIONS.map((option) => [option.value, option]));
const TEACHER_TAG_COLOR_OPTIONS = [
	'bright-blue',
	'blue',
	'pastel-blue',
	'pastel-light-blue',
	'turquoise',
	'pastel-turquoise',
	'pastel-light-turquoise',
	'bright-green',
	'green',
	'pastel-green',
	'pastel-light-green',
	'bright-purple',
	'purple',
	'pastel-dark-purple',
	'pastel-light-purple',
	'dark-purple',
	'dark-blue',
	'dark-blue-gray',
	'pastel-dark-blue-gray',
	'dark-purple-gray',
	'orange',
	'dark-orange',
	'pastel-orange',
	'pastel-light-orange',
	'yellow',
	'bright-yellow',
	'pastel-yellow',
	'pastel-light-yellow',
	'pastel-brown',
	'dark-brown',
	'elem-tag-cool-01',
	'elem-tag-cool-02',
	'elem-tag-cool-03',
	'elem-tag-cool-04',
	'elem-tag-cool-05',
	'elem-tag-cool-06',
	'elem-tag-cool-07',
	'elem-tag-cool-08',
	'elem-tag-cool-09',
	'elem-tag-cool-10',
	'elem-tag-cool-11',
	'elem-tag-cool-12',
	'elem-tag-cool-13',
	'elem-tag-cool-14',
	'elem-tag-cool-15',
	'elem-tag-cool-16',
	'elem-tag-cool-17',
	'elem-tag-cool-18',
	'elem-tag-cool-19',
	'elem-tag-cool-20',
	'elem-tag-cool-21',
	'elem-tag-cool-22',
	'elem-tag-cool-23',
	'elem-tag-cool-24'
].filter((color_value) => color_value !== 'red' && color_value !== 'bright-red').map((color_value) => TEACHER_TAG_COLOR_OPTION_MAP.get(color_value)).filter(Boolean);
const VALID_TEACHER_TAG_COLORS = new Set(ALL_TEACHER_TAG_COLOR_OPTIONS.map(option => option.value));
const TEACHER_TAG_COLOR_HEX_MAP = {
	'red': '#c0392b',
	'bright-red': '#e74c3c',
	'orange': '#e67e22',
	'dark-orange': '#d35400',
	'yellow': '#f39c12',
	'bright-yellow': '#f1c40f',
	'green': '#27ae60',
	'bright-green': '#2ecc71',
	'turquoise': '#16a085',
	'blue': '#2980b9',
	'bright-blue': '#3498db',
	'dark-blue': '#092745',
	'dark-blue-gray': '#092745',
	'pastel-dark-blue-gray': '#678aae',
	'purple': '#8e44ad',
	'bright-purple': '#9b59b6',
	'pastel-light-green': '#55efc4',
	'pastel-green': '#00b894',
	'pastel-light-turquoise': '#81ecec',
	'pastel-turquoise': '#00cec9',
	'pastel-light-blue': '#74b9ff',
	'pastel-blue': '#0984e3',
	'pastel-light-purple': '#a29bfe',
	'dark-purple': '#474ccb',
	'dark-purple-gray': '#56588b',
	'pastel-dark-purple': '#6c5ce7',
	'pastel-light-yellow': '#ffeaa7',
	'pastel-yellow': '#fdcb6e',
	'pastel-light-orange': '#fab1a0',
	'pastel-orange': '#e17055',
	'pastel-brown': '#bc9e82',
	'dark-brown': '#695848',
	'light-gray': '#ecf0f1',
	'gray': '#cad1d2',
	'dark-gray': '#7f8c8d',
	'white': '#ffffff',
	'elem-tag-cool-01': '#0b6e4f',
	'elem-tag-cool-02': '#1f7a8c',
	'elem-tag-cool-03': '#2a628f',
	'elem-tag-cool-04': '#3b4cc0',
	'elem-tag-cool-05': '#5e60ce',
	'elem-tag-cool-06': '#4361ee',
	'elem-tag-cool-07': '#3a86ff',
	'elem-tag-cool-08': '#0077b6',
	'elem-tag-cool-09': '#0096c7',
	'elem-tag-cool-10': '#00a8a8',
	'elem-tag-cool-11': '#1b9e77',
	'elem-tag-cool-12': '#2d6a4f',
	'elem-tag-cool-13': '#3a5a40',
	'elem-tag-cool-14': '#4a4e69',
	'elem-tag-cool-15': '#5f0f99',
	'elem-tag-cool-16': '#6a4c93',
	'elem-tag-cool-17': '#4f5d75',
	'elem-tag-cool-18': '#3d405b',
	'elem-tag-cool-19': '#264653',
	'elem-tag-cool-20': '#2f4858',
	'elem-tag-cool-21': '#577590',
	'elem-tag-cool-22': '#277da1',
	'elem-tag-cool-23': '#4d908e',
	'elem-tag-cool-24': '#43aa8b'
};

const normalizeTeacherTagColorClass = (tag_color) => {
	if(!tag_color) return DEFAULT_TEACHER_TAG_COLOR;
	let normalized_tag_color = `${tag_color}`.trim().toLowerCase().replace(/_/g, '-');
	if(normalized_tag_color === 'light-grey') normalized_tag_color = 'light-gray';
	if(normalized_tag_color === 'grey') normalized_tag_color = 'gray';
	if(normalized_tag_color === 'dark-grey') normalized_tag_color = 'dark-gray';
	if(normalized_tag_color === 'dark-blue-grey') normalized_tag_color = 'dark-blue-gray';
	if(normalized_tag_color === 'pastel-dark-blue-grey') normalized_tag_color = 'pastel-dark-blue-gray';
	if(normalized_tag_color === 'dark-purple-grey') normalized_tag_color = 'dark-purple-gray';
	return VALID_TEACHER_TAG_COLORS.has(normalized_tag_color) ? normalized_tag_color : DEFAULT_TEACHER_TAG_COLOR;
};

const getTeacherTagColorClass = (teacher_info) => {
	return normalizeTeacherTagColorClass(teacher_info?.tag_color);
};

const displayTeacherName = (teacher) => {
	if(!teacher) return '';
	const first_name = (teacher.first_name) ? `${teacher.first_name}`.trim() : '';
	const last_name = (teacher.name) ? `${teacher.name}`.trim() : '';
	return `${last_name}, ${first_name}`.replace(/,\s*$/, '');
};

const normalizeGradeLabel = (grade_value) => {
	if(grade_value === null || typeof grade_value === 'undefined') return '';
	const grade_string = `${grade_value}`.trim();
	if(!grade_string) return '';

	const normalized_compare = grade_string
		.toLowerCase()
		.replace(/\./g, '')
		.replace(/[-_]/g, ' ')
		.replace(/\s+/g, ' ')
		.trim();

	if(normalized_compare === '0' || normalized_compare === 'k' || normalized_compare === 'grade k' || normalized_compare === 'kindergarten' || normalized_compare === 'kg') return 'K';
	if(normalized_compare === 'pk' || normalized_compare === 'grade pk' || normalized_compare === 'prek' || normalized_compare === 'pre k' || normalized_compare === 'prekindergarten' || normalized_compare === 'pre kindergarten') return 'PK';
	if(normalized_compare === 'unassigned' || normalized_compare === 'grade unassigned') return 'Unassigned';

	const without_grade_prefix = normalized_compare.replace(/^grade\s+/, '').trim();
	if(/^\d+$/.test(without_grade_prefix))
	{
		const parsed_grade_number = parseInt(without_grade_prefix, 10);
		if(!Number.isNaN(parsed_grade_number)) return `${parsed_grade_number}`;
	}

	return grade_string;
};

const sortGradeLabels = (grade_label_a, grade_label_b) => {
	const label_a = normalizeGradeLabel(grade_label_a);
	const label_b = normalizeGradeLabel(grade_label_b);

	if(label_a === 'PK') return -1;
	if(label_b === 'PK') return 1;
	if(label_a === 'K') return -1;
	if(label_b === 'K') return 1;
	if(label_a === 'Unassigned') return 1;
	if(label_b === 'Unassigned') return -1;

	const label_a_number = parseInt(label_a, 10);
	const label_b_number = parseInt(label_b, 10);
	const label_a_is_number = !Number.isNaN(label_a_number);
	const label_b_is_number = !Number.isNaN(label_b_number);
	if(label_a_is_number && label_b_is_number) return label_a_number - label_b_number;
	if(label_a_is_number) return -1;
	if(label_b_is_number) return 1;

	return `${label_a}`.localeCompare(`${label_b}`);
};

const formatGradeLabelDisplay = (grade_label) => {
	const normalized_label = normalizeGradeLabel(grade_label);
	if(!normalized_label) return '';
	if(normalized_label === 'Unassigned') return 'Unassigned';
	if(normalized_label === 'PK') return 'PreK';
	if(normalized_label === 'K') return 'Kindergarten';
	if(/^\d+$/.test(normalized_label)) return `Grade ${normalized_label}`;
	return normalized_label;
};

const getTeacherGradeLabelsDisplay = (teacher_info, fallback_grade_label = '') => {
	const grade_labels_set = new Set();

	const addGradeLabel = (raw_grade_label) => {
		const normalized_label = normalizeGradeLabel(raw_grade_label);
		if(!normalized_label) return;
		grade_labels_set.add(normalized_label);
	};

	addGradeLabel(teacher_info?.grade_label);
	addGradeLabel(fallback_grade_label);

	const unplaced_cards = Array.isArray(teacher_info?.unplaced_cards) ? teacher_info.unplaced_cards : [];
	unplaced_cards.forEach((card_info) => addGradeLabel(card_info?.grade_label));

	const grade_labels = [...grade_labels_set].sort(sortGradeLabels);
	return grade_labels.map((grade_label) => formatGradeLabelDisplay(grade_label)).filter(Boolean).join(' • ');
};

const timeToMinutes = (time_value) => {
	if(!time_value || typeof time_value !== 'string') return null;
	const [hours_raw, minutes_raw] = time_value.split(':');
	const hours = parseInt(hours_raw, 10);
	const minutes = parseInt(minutes_raw, 10);
	if(Number.isNaN(hours) || Number.isNaN(minutes)) return null;
	return hours * 60 + minutes;
};

const timesOverlap = (start_time_1, end_time_1, start_time_2, end_time_2) => {
	const start_1 = timeToMinutes(start_time_1);
	const end_1 = timeToMinutes(end_time_1);
	const start_2 = timeToMinutes(start_time_2);
	const end_2 = timeToMinutes(end_time_2);

	if(start_1 === null || end_1 === null || start_2 === null || end_2 === null) return false;
	return end_1 > start_2 && end_2 > start_1;
};

const createTeacherCodeBase = (teacher) => {
	const first_name = (teacher?.first_name) ? `${teacher.first_name}`.trim() : '';
	const last_name = (teacher?.name) ? `${teacher.name}`.trim() : '';

	if(first_name && last_name) return `${first_name[0]}${last_name[0]}`.toUpperCase();
	if(last_name) return `${last_name.slice(0, 2)}`.toUpperCase();
	if(first_name) return `${first_name.slice(0, 2)}`.toUpperCase();
	return 'T';
};

const createCourseAbbreviation = (course_name) => {
	const course_string = `${course_name || ''}`.trim();
	if(!course_string) return '';

	const words = course_string.replace(/[^a-zA-Z0-9\s]/g, ' ').split(/\s+/).filter(Boolean);
	if(words.length === 0) return '';
	if(words.length === 1)
	{
		const single_word = words[0].toUpperCase();
		return (single_word.length <= 4) ? single_word : single_word.slice(0, 4);
	}

	const initials = words.map(word => word[0]).join('').toUpperCase();
	return (initials.length <= 4) ? initials : initials.slice(0, 4);
};

const stripCourseLengthFromDisplayName = (course_name) => {
	const normalized_name = `${course_name || ''}`.trim();
	if(!normalized_name) return '';

	const course_length_token = '(?:full\\s*year|year\\s*long|year|semester(?:\\s*[12])?|sem(?:\\s*[12])?|s(?:\\s*[12])?\\.?|quarter(?:\\s*[1-4])?|q(?:\\s*[1-4])?\\.?|q[1-4](?:\\s*\\/\\s*q[1-4])?|trimester(?:\\s*[1-3])?|tri(?:\\s*[1-3])?|fy|sy)';
	const course_length_word_token = '(?:full\\s*year|year\\s*long|year|semester(?:\\s*[12])?|sem(?:\\s*[12])?|quarter(?:\\s*[1-4])?|trimester(?:\\s*[1-3])?)';
	const bracketed_suffix_regex = new RegExp(`\\s*[\\(\\[]\\s*${course_length_token}\\s*[\\)\\]]\\s*$`, 'i');
	const separator_suffix_regex = new RegExp(`\\s*(?:-|,|:)\\s*${course_length_token}\\s*$`, 'i');
	const plain_word_suffix_regex = new RegExp(`\\s+${course_length_word_token}\\s*$`, 'i');

	let stripped_name = normalized_name;
	let keep_cleaning = true;

	while(keep_cleaning)
	{
		const next_name = stripped_name.replace(bracketed_suffix_regex, '').replace(separator_suffix_regex, '').replace(plain_word_suffix_regex, '').trim();
		keep_cleaning = next_name !== stripped_name;
		stripped_name = next_name;
	}

	return stripped_name || normalized_name;
};

const createAbbreviationFromDisplayName = (display_name) => {
	const normalized_name = `${display_name || ''}`.trim();
	if(!normalized_name) return '';

	if(normalized_name.includes(','))
	{
		const [last_name_raw, first_name_raw] = normalized_name.split(',');
		const last_name = `${last_name_raw || ''}`.trim();
		const first_name = `${first_name_raw || ''}`.trim();

		if(first_name && last_name) return `${first_name[0]}${last_name[0]}`.toUpperCase();
		if(last_name) return `${last_name.slice(0, 2)}`.toUpperCase();
	}

	const words = normalized_name.split(/\s+/).filter(Boolean);
	if(words.length === 0) return '';
	if(words.length === 1)
	{
		const single_word = words[0].toUpperCase();
		return (single_word.length <= 4) ? single_word : single_word.slice(0, 4);
	}

	const initials = words.map(word => word[0]).join('').toUpperCase();
	return (initials.length <= 4) ? initials : initials.slice(0, 4);
};

const setLargeDragPreview = (event, title, subtitle = '', tag_color_class = DEFAULT_TEACHER_TAG_COLOR) => {
	if(!event || !event.dataTransfer || typeof document === 'undefined') return;

	const drag_preview = document.createElement('div');
	drag_preview.className = 'specials-review-drag-preview';

	const accent_node = document.createElement('div');
	accent_node.className = `specials-review-drag-preview-accent ${normalizeTeacherTagColorClass(tag_color_class)}`;
	const grip_icon_node = document.createElement('div');
	grip_icon_node.className = 'specials-review-drag-preview-grip-icon';
	try
	{
		const rendered_icon = fontawesomeIcon(faEllipsisV);
		if(rendered_icon && Array.isArray(rendered_icon.html) && rendered_icon.html[0]) grip_icon_node.innerHTML = rendered_icon.html[0];
		else grip_icon_node.textContent = '⋮';
	}
	catch(error)
	{
		grip_icon_node.textContent = '⋮';
	}
	accent_node.appendChild(grip_icon_node);
	drag_preview.appendChild(accent_node);

	const title_node = document.createElement('div');
	title_node.className = 'specials-review-drag-preview-title';
	title_node.textContent = title;
	drag_preview.appendChild(title_node);

	if(subtitle)
	{
		const subtitle_node = document.createElement('div');
		subtitle_node.className = 'specials-review-drag-preview-subtitle';
		subtitle_node.textContent = subtitle;
		drag_preview.appendChild(subtitle_node);
	}

	try
	{
		document.body.appendChild(drag_preview);
		event.dataTransfer.setDragImage(drag_preview, 16, 16);
	}
	catch(error)
	{
		// If drag preview customization fails in a browser, keep default drag behavior.
	}
	finally
	{
		setTimeout(() => {
			if(drag_preview.parentNode) drag_preview.parentNode.removeChild(drag_preview);
		}, 0);
	}
};

const hexToRgb = (hex_color) => {
	const normalized_hex = `${hex_color || ''}`.trim().replace('#', '');
	if(normalized_hex.length !== 6) return null;
	const red = parseInt(normalized_hex.slice(0, 2), 16);
	const green = parseInt(normalized_hex.slice(2, 4), 16);
	const blue = parseInt(normalized_hex.slice(4, 6), 16);
	if(Number.isNaN(red) || Number.isNaN(green) || Number.isNaN(blue)) return null;
	return {red, green, blue};
};

const getDraggableCardTintStyle = (tag_color_class) => {
	const normalized_tag_color = normalizeTeacherTagColorClass(tag_color_class);
	const hex_color = TEACHER_TAG_COLOR_HEX_MAP[normalized_tag_color] || TEACHER_TAG_COLOR_HEX_MAP[DEFAULT_TEACHER_TAG_COLOR];
	const rgb = hexToRgb(hex_color);
	if(!rgb) return null;
	return {
		backgroundColor: `rgba(${rgb.red}, ${rgb.green}, ${rgb.blue}, 0.18)`,
		borderColor: `rgba(${rgb.red}, ${rgb.green}, ${rgb.blue}, 0.55)`,
		color: '#1f3b57'
	};
};

const getPlannerSpecialFilterValue = (card_info) => {
	if(!card_info) return null;
	const special_id = `${card_info.course_id || card_info.label || ''}`.trim();
	return special_id || null;
};

const getPlannerSpecialFilterDisplay = (card_info) => {
	if(!card_info) return '';
	return `${card_info.course_name || card_info.label || ''}`.trim();
};

const getPlannerFilterTitleDisplay = (filter_title) => {
	if(filter_title === 'grades') return 'Grade';
	if(filter_title === 'teachers') return 'Teacher';
	if(filter_title === 'specials') return 'Special To Place';
	return `${filter_title}`;
};

const formatPeriodTimeDisplay = (time_value) => {
	if(!time_value || typeof time_value !== 'string') return '';
	const time_parts = `${time_value}`.trim().split(':');
	if(time_parts.length < 2) return `${time_value}`;
	const hours_24 = parseInt(time_parts[0], 10);
	const minutes = parseInt(time_parts[1], 10);
	if(Number.isNaN(hours_24) || Number.isNaN(minutes)) return `${time_value}`;

	const period = (hours_24 >= 12) ? 'PM' : 'AM';
	let hours_12 = hours_24 % 12;
	if(hours_12 === 0) hours_12 = 12;

	return `${hours_12}:${`${minutes}`.padStart(2, '0')} ${period}`;
};

const getQuickViewPositionFromEvent = (event, panel_width = 320) => {
	const fallback_position = {left: 24, top: 24};
	if(!event || typeof window === 'undefined') return fallback_position;

	const viewport_width = window.innerWidth || 1200;
	const viewport_height = window.innerHeight || 800;
	const margin = 14;
	const max_left = Math.max(margin, viewport_width - panel_width - margin);
	const max_top = Math.max(margin, viewport_height - 190);
	const left = Math.min(Math.max(margin, event.clientX + 16), max_left);
	const top = Math.min(Math.max(margin, event.clientY + 16), max_top);
	return {left, top};
};

const isSpecialNonLunchBlock = (block_info) => {
	if(!block_info) return false;
	const is_special = `${block_info.is_special || '0'}` === '1';
	const is_lunch = `${block_info.is_lunch || '0'}` === '1';
	return is_special && !is_lunch;
};

/*
 * Legacy frontend auto placer helpers.
 * These are intentionally commented out while specials auto placing runs through
 * the backend `/elementary/schedule-specials` job instead.
 *
 * const createTeacherDayKey = (day_number, teacher_id) => `${day_number}__${teacher_id}`;
 * const createTeacherPeriodKey = (day_number, period_row_id, teacher_id) => `${day_number}__${period_row_id}__${teacher_id}`;
 * const createHomeroomDayKey = (day_number, homeroom_teacher_id) => `${day_number}__${homeroom_teacher_id}`;
 *
 * const arePlacementsEqual = (placement_a, placement_b) => {
 * 	if(!placement_a || !placement_b) return false;
 * 	return `${placement_a.day_number || ''}` === `${placement_b.day_number || ''}` && `${placement_a.period_row_id || ''}` === `${placement_b.period_row_id || ''}` && `${placement_a.specials_teacher_id || ''}` === `${placement_b.specials_teacher_id || ''}`;
 * };
 */

const DEFAULT_AUTO_PLACER_PROGRESS = {
	visible: false,
	percent: 0,
	phase_label: '',
	status_line: '',
	step_log: []
};

const DEFAULT_CLEAR_ALL_PROGRESS = {
	visible: false,
	percent: 0,
	phase_label: '',
	status_line: ''
};

const sleep = (duration_ms = 0) => new Promise((resolve) => setTimeout(resolve, Math.max(0, duration_ms)));

export default function PlaceSpecials({ isLoading, subscreenLocked, subscreenRestricted, schoolInfo, scheduleInfo, periods = [], courses = [], teachers = [], setTeachers = () => {}, students = [], blocks = [], setBlocks = () => {}, homeroomGradeGroups = [], handleMoveToNextScreen }) {
	const [draggingCardID, setDraggingCardID] = useState(null);
	const [draggingExistingID, setDraggingExistingID] = useState(null);
	const [activeDropCellKey, setActiveDropCellKey] = useState(null);
	const [pendingPlacementCellKey, setPendingPlacementCellKey] = useState(null);
	const [pendingRemovalItemKey, setPendingRemovalItemKey] = useState(null);
	const [cardPlacements, setCardPlacements] = useState({});
	const [movedExistingPlacements, setMovedExistingPlacements] = useState({});
	const [unassignedPlannerCardIDs, setUnassignedPlannerCardIDs] = useState({});
	const [unassignedExistingIDs, setUnassignedExistingIDs] = useState({});
	const [persistedPlannerBlockIDs, setPersistedPlannerBlockIDs] = useState({});
	const [plannerFilterVisible, setPlannerFilterVisible] = useState(false);
	const [selectedPlannerGradeFilter, setSelectedPlannerGradeFilter] = useState('');
	const [hideCompletedTeachers, setHideCompletedTeachers] = useState(true);
	const [legendVisible, setLegendVisible] = useState(false);
	const [legendPopoverStyle, setLegendPopoverStyle] = useState({});
	const [gridActionsVisible, setGridActionsVisible] = useState(false);
	const [gridSpecialsTeacherFilterVisible, setGridSpecialsTeacherFilterVisible] = useState(false);
	const [gridHomeroomTeacherFilterVisible, setGridHomeroomTeacherFilterVisible] = useState(false);
	const [selectedGridSpecialsTeacherIDs, setSelectedGridSpecialsTeacherIDs] = useState([]);
	const [selectedGridHomeroomTeacherIDs, setSelectedGridHomeroomTeacherIDs] = useState([]);
	const [isClearingAllSpecials, setIsClearingAllSpecials] = useState(false);
	const [clearAllProgress, setClearAllProgress] = useState(DEFAULT_CLEAR_ALL_PROGRESS);
	const [isRunningAutoPlacer, setIsRunningAutoPlacer] = useState(false);
	const [autoPlacerProgress, setAutoPlacerProgress] = useState(DEFAULT_AUTO_PLACER_PROGRESS);
	const [showInitialCalculationSkeleton, setShowInitialCalculationSkeleton] = useState(true);
	const [plannerOpenFilterOptions, setPlannerOpenFilterOptions] = useState([]);
	const [plannerFilterOptions, setPlannerFilterOptions] = useState({
		teachers: [],
		specials: []
	});
	const [blockQuickView, setBlockQuickView] = useState(null);
	const [rowQuickView, setRowQuickView] = useState(null);
	const draggingPayloadRef = useRef({type:null, id:null});
	const planner_filter_ref = useRef();
	const grid_actions_ref = useRef();
	const grid_specials_teacher_filter_ref = useRef();
	const grid_homeroom_teacher_filter_ref = useRef();
	const legend_popover_ref = useRef();
	const legend_help_button_ref = useRef();
	const auto_assign_colors_in_progress_ref = useRef(false);
	const initial_calculation_complete_ref = useRef(false);

	useOutsideClick(planner_filter_ref, () => {
		setPlannerFilterVisible(false);
	});

	useEffect(() => {
		if(plannerFilterVisible) return;
		setPlannerOpenFilterOptions([]);
	}, [plannerFilterVisible]);

	useOutsideClick(grid_actions_ref, () => {
		setGridActionsVisible(false);
	});

	useOutsideClick(grid_specials_teacher_filter_ref, () => {
		setGridSpecialsTeacherFilterVisible(false);
	});

	useOutsideClick(grid_homeroom_teacher_filter_ref, () => {
		setGridHomeroomTeacherFilterVisible(false);
	});

	useEffect(() => {
		if(!legendVisible) return;

		const updateLegendPopoverPosition = () => {
			const trigger_element = legend_help_button_ref.current;
			if(!trigger_element || typeof window === 'undefined') return;

			const rect = trigger_element.getBoundingClientRect();
			const margin = 12;
			const estimated_width = Math.min(340, Math.max(220, (window.innerWidth || 800) - (margin * 2)));
			const computed_left = Math.min(Math.max(margin, rect.left), (window.innerWidth || 800) - margin - estimated_width);
			const computed_top = Math.min(rect.bottom + 6, (window.innerHeight || 700) - margin - 140);
			const computed_max_height = Math.min(Math.floor((window.innerHeight || 700) * 0.55), 360);

			setLegendPopoverStyle({
				top: computed_top,
				left: computed_left,
				width: estimated_width,
				maxHeight: computed_max_height
			});
		};

		const handleLegendOutsideClick = (event) => {
			const clicked_element = event.target;
			if(legend_popover_ref.current && legend_popover_ref.current.contains(clicked_element)) return;
			if(legend_help_button_ref.current && legend_help_button_ref.current.contains(clicked_element)) return;
			setLegendVisible(false);
		};

		updateLegendPopoverPosition();
		document.addEventListener('click', handleLegendOutsideClick);
		window.addEventListener('resize', updateLegendPopoverPosition);
		window.addEventListener('scroll', updateLegendPopoverPosition, true);

		return () => {
			document.removeEventListener('click', handleLegendOutsideClick);
			window.removeEventListener('resize', updateLegendPopoverPosition);
			window.removeEventListener('scroll', updateLegendPopoverPosition, true);
		};
	}, [legendVisible]);

	const special_course_ids = useMemo(() => {
		return new Set(courses.filter(course => `${course.is_special || '0'}` === '1').map(course => `${course.course_id}`));
	}, [courses]);

	const cycle_days = useMemo(() => {
		const parsed_num_days = parseInt(scheduleInfo?.num_days_in_cycle || '1', 10);
		const num_days = (!Number.isNaN(parsed_num_days) && parsed_num_days > 0) ? parsed_num_days : 1;
		return Array.from({length: num_days}, (_, index) => `${index + 1}`);
	}, [scheduleInfo]);

	const teacher_name_map = useMemo(() => {
		return new Map(teachers.map(teacher => [`${teacher.teacher_id}`, displayTeacherName(teacher)]));
	}, [teachers]);

	const teacher_abbrev_map = useMemo(() => {
		return new Map(teachers.map((teacher) => {
			const teacher_display_name = displayTeacherName(teacher);
			const teacher_abbreviation = createTeacherCodeBase(teacher);
			const fallback_abbreviation = createAbbreviationFromDisplayName(teacher_display_name);
			return [`${teacher.teacher_id}`, teacher_abbreviation || fallback_abbreviation || 'T'];
		}));
	}, [teachers]);

	const teacher_tag_color_map = useMemo(() => {
		return new Map(teachers.map(teacher => [`${teacher.teacher_id}`, getTeacherTagColorClass(teacher)]));
	}, [teachers]);

	const specials_teachers = useMemo(() => {
		const selected_teachers = teachers.filter((teacher) => {
			const teacher_can_teach = (Array.isArray(teacher.teacher_can_teach)) ? teacher.teacher_can_teach : [];
			const teaches_special_course = teacher_can_teach.some(tct_info => special_course_ids.has(`${tct_info.course_id}`));
			const explicitly_marked_specials = `${teacher.is_specials_teacher || '0'}` === '1';
			return teaches_special_course || explicitly_marked_specials;
		});

		return selected_teachers.sort((teacher_a, teacher_b) => {
			return displayTeacherName(teacher_a).toLowerCase().localeCompare(displayTeacherName(teacher_b).toLowerCase());
		});
	}, [teachers, special_course_ids]);

	const teacher_header_meta = useMemo(() => {
		const used_codes = new Set();

		return specials_teachers.map((teacher, index) => {
			const base_code = createTeacherCodeBase(teacher);
			let code = base_code;
			let suffix_number = 2;

			while(used_codes.has(code))
			{
				code = `${base_code}${suffix_number}`;
				suffix_number += 1;
			}
			used_codes.add(code);

			return {
				teacher_id: `${teacher.teacher_id}`,
				full_name: displayTeacherName(teacher) || `Teacher ${index + 1}`,
				code
			};
		});
	}, [specials_teachers]);

	const selected_grid_specials_teacher_id_set = useMemo(() => {
		return new Set((selectedGridSpecialsTeacherIDs || []).map((teacher_id) => `${teacher_id || ''}`.trim()).filter(Boolean));
	}, [selectedGridSpecialsTeacherIDs]);

	const visible_teacher_header_meta = useMemo(() => {
		if(selected_grid_specials_teacher_id_set.size === 0) return teacher_header_meta;
		return teacher_header_meta.filter((teacher_meta) => selected_grid_specials_teacher_id_set.has(`${teacher_meta.teacher_id || ''}`));
	}, [teacher_header_meta, selected_grid_specials_teacher_id_set]);

	const teacher_col_count_per_day = Math.max(1, visible_teacher_header_meta.length);

	const period_rows = useMemo(() => {
		const period_list = periods.map((period, index) => {
			const start_minutes = timeToMinutes(period.start_time);
			return {
				...period,
				_specials_review_row_id: `${period.period_id || 'period'}-${index}`,
				_specials_review_start_minutes: (start_minutes === null) ? 0 : start_minutes
			};
		});

		return period_list.sort((period_a, period_b) => {
			if(period_a._specials_review_start_minutes !== period_b._specials_review_start_minutes) return period_a._specials_review_start_minutes - period_b._specials_review_start_minutes;
			return `${period_a.period_name || ''}`.localeCompare(`${period_b.period_name || ''}`);
		});
	}, [periods]);

	const period_by_row_id_map = useMemo(() => {
		return new Map(period_rows.map(period => [period._specials_review_row_id, period]));
	}, [period_rows]);

	const course_map = useMemo(() => {
		return new Map(courses.map(course => [`${course.course_id}`, course]));
	}, [courses]);

	const school_id = `${schoolInfo?.school_id || ''}`.trim();
	const schedule_version_id = `${schoolInfo?.current_schedule_version_id || scheduleInfo?.schedule_version_id || ''}`.trim();

	const block_by_id_map = useMemo(() => {
		const results = new Map();
		blocks.forEach((block_info) => {
			const block_id = `${block_info?.block_id || ''}`.trim();
			if(!block_id) return;
			results.set(block_id, block_info);
		});
		return results;
	}, [blocks]);

	const course_allowed_teacher_ids_map = useMemo(() => {
		const results = new Map();

		courses.forEach((course) => {
			const course_id = `${course?.course_id || ''}`.trim();
			if(!course_id) return;

			const teachers_can_teach = Array.isArray(course?.teachers_can_teach) ? course.teachers_can_teach : [];
			const allowed_teacher_ids = new Set();

			teachers_can_teach.forEach((teacher_info) => {
				if(teacher_info === null || typeof teacher_info === 'undefined') return;
				const teacher_id = (typeof teacher_info === 'object') ? teacher_info.teacher_id : teacher_info;
				const normalized_teacher_id = `${teacher_id || ''}`.trim();
				if(!normalized_teacher_id) return;
				allowed_teacher_ids.add(normalized_teacher_id);
			});

			results.set(course_id, allowed_teacher_ids);
		});

		return results;
	}, [courses]);

	const specials_blocks = useMemo(() => {
		return blocks.filter(block => `${block.is_special || '0'}` === '1' || `${block.is_lunch || '0'}` === '1');
	}, [blocks]);

	const existing_block_item_map = useMemo(() => {
		const results = {};
		const teacher_ids = teacher_header_meta.map(meta => `${meta.teacher_id}`);

		for(const period of period_rows)
		{
			for(const day_number of cycle_days)
			{
				const period_days = (Array.isArray(period.days)) ? period.days.map(day => `${day}`) : [];
				const period_runs_this_day = period_days.includes(`${day_number}`);
				if(!period_runs_this_day) continue;

				for(const teacher_id of teacher_ids)
				{
					const matched_blocks = specials_blocks.filter((block) => {
						if(`${block.day_number || ''}` !== `${day_number}`) return false;
						const block_primary_teacher_id = `${block.teacher_id || ''}`;
						const secondary_teacher_ids = (Array.isArray(block.secondary_teachers)) ? block.secondary_teachers.map(id => `${id}`) : [];
						const teacher_matches_block = (block_primary_teacher_id === `${teacher_id}` || secondary_teacher_ids.includes(`${teacher_id}`));
						if(!teacher_matches_block) return false;

						return timesOverlap(period.start_time, period.end_time, block.start_time, block.end_time);
					}).sort((block_a, block_b) => {
						const block_a_start = timeToMinutes(block_a.start_time) || 0;
						const block_b_start = timeToMinutes(block_b.start_time) || 0;
						return block_a_start - block_b_start;
					});

					matched_blocks.forEach((block, index) => {
						const is_lunch = `${block.is_lunch || '0'}` === '1';
						const course_info = course_map.get(`${block.course_id}`);
						const raw_course_name = (is_lunch) ? 'Lunch' : ((course_info && course_info.name) ? course_info.name : 'Untitled');
						const course_name = stripCourseLengthFromDisplayName(raw_course_name);
						const day_period_restrictions = (course_info && Array.isArray(course_info.day_period_restrictions)) ? course_info.day_period_restrictions : [];
						const homeroom_teacher_name = teacher_name_map.get(`${block.homeroom_teacher_id}`) || 'No Homeroom Teacher';
						const course_abbreviation = createCourseAbbreviation(course_name);
						const homeroom_teacher_abbreviation = teacher_abbrev_map.get(`${block.homeroom_teacher_id}`) || createAbbreviationFromDisplayName(homeroom_teacher_name);
						const tag_color = teacher_tag_color_map.get(`${block.homeroom_teacher_id}`) || DEFAULT_TEACHER_TAG_COLOR;
						const existing_instance_id = `${block.block_id || 'block'}__${day_number}__${teacher_id}__${period._specials_review_row_id}__${index}`;

						results[existing_instance_id] = {
							existing_instance_id,
							block_id: block.block_id,
							course_id: `${block.course_id || ''}`,
							label: course_name,
							label_abbrev: course_abbreviation || course_name,
							homeroom_teacher_id: `${block.homeroom_teacher_id || ''}`,
							homeroom_teacher_name,
							homeroom_teacher_abbrev: homeroom_teacher_abbreviation || homeroom_teacher_name,
							tag_color,
							day_period_restrictions,
							original_placement: {
								period_row_id: `${period._specials_review_row_id}`,
								day_number: `${day_number}`,
								specials_teacher_id: `${teacher_id}`
							}
						};
					});
				}
			}
		}

		return results;
	}, [period_rows, cycle_days, teacher_header_meta, specials_blocks, course_map, teacher_name_map, teacher_abbrev_map, teacher_tag_color_map]);

	const existing_cell_blocks_lookup = useMemo(() => {
		const lookup = {};
		const existing_items = Object.values(existing_block_item_map);
		const unassigned_existing_ids = new Set(Object.keys(unassignedExistingIDs));
		const unassigned_existing_block_ids = new Set();
		unassigned_existing_ids.forEach((existing_instance_id) => {
			const existing_item = existing_block_item_map[existing_instance_id];
			const existing_block_id = `${existing_item?.block_id || ''}`.trim();
			if(existing_block_id) unassigned_existing_block_ids.add(existing_block_id);
		});

		for(const period of period_rows)
		{
			for(const day_number of cycle_days)
			{
				for(const teacher_meta of teacher_header_meta)
				{
					const teacher_id = `${teacher_meta.teacher_id}`;
					const key = `${period._specials_review_row_id}__${day_number}__${teacher_id}`;
					lookup[key] = [];
				}
			}
		}

		existing_items.forEach((existing_item) => {
			const existing_instance_id = existing_item.existing_instance_id;
			if(unassigned_existing_ids.has(existing_instance_id)) return;
			const existing_block_id = `${existing_item?.block_id || ''}`.trim();
			if(existing_block_id && unassigned_existing_block_ids.has(existing_block_id)) return;

			const moved_placement = movedExistingPlacements[existing_instance_id];
			const placement = moved_placement || existing_item.original_placement;
			if(!placement) return;
			const target_key = `${placement.period_row_id}__${placement.day_number}__${placement.specials_teacher_id}`;
			if(!(target_key in lookup)) lookup[target_key] = [];
			lookup[target_key].push({...existing_item, moved: Boolean(moved_placement)});
		});

		return lookup;
	}, [period_rows, cycle_days, teacher_header_meta, movedExistingPlacements, unassignedExistingIDs, existing_block_item_map]);

	const unassigned_existing_block_id_set = useMemo(() => {
		const results = new Set();
		Object.keys(unassignedExistingIDs).forEach((existing_instance_id) => {
			const existing_item = existing_block_item_map[existing_instance_id];
			const block_id = `${existing_item?.block_id || ''}`.trim();
			if(block_id) results.add(block_id);
		});
		return results;
	}, [unassignedExistingIDs, existing_block_item_map]);

	const homeroom_teacher_grade_map = useMemo(() => {
		const grade_counts_by_teacher = {};
		const grade_map = new Map();

		if(Array.isArray(homeroomGradeGroups))
		{
			homeroomGradeGroups.forEach((grade_group) => {
				const normalized_grade_label = normalizeGradeLabel(grade_group?.label || grade_group?.grade_label || grade_group?.grade || '');
				if(!normalized_grade_label) return;
				const teacher_ids = (Array.isArray(grade_group?.teacher_ids)) ? grade_group.teacher_ids
					: (Array.isArray(grade_group?.teacherIds)) ? grade_group.teacherIds
					: (Array.isArray(grade_group?.teachers)) ? grade_group.teachers.map((teacher_info) => {
						if(teacher_info && typeof teacher_info === 'object') return teacher_info.teacher_id || teacher_info.id || null;
						return teacher_info;
					}) : [];
				teacher_ids.forEach((teacher_id) => {
					const normalized_teacher_id = `${teacher_id || ''}`.trim();
					if(!normalized_teacher_id || grade_map.has(normalized_teacher_id)) return;
					grade_map.set(normalized_teacher_id, normalized_grade_label);
				});
			});
		}

		for(const student of students)
		{
			const homeroom_teacher_id = `${student?.homeroom_teacher_id || ''}`.trim();
			if(!homeroom_teacher_id) continue;

			const normalized_grade = normalizeGradeLabel(student.grade);
			if(!normalized_grade) continue;

			if(!(homeroom_teacher_id in grade_counts_by_teacher)) grade_counts_by_teacher[homeroom_teacher_id] = {};
			if(!(normalized_grade in grade_counts_by_teacher[homeroom_teacher_id])) grade_counts_by_teacher[homeroom_teacher_id][normalized_grade] = 0;
			grade_counts_by_teacher[homeroom_teacher_id][normalized_grade] += 1;
		}

		Object.keys(grade_counts_by_teacher).forEach((teacher_id) => {
			if(grade_map.has(`${teacher_id}`)) return;
			const grade_counts = grade_counts_by_teacher[teacher_id];
			const sorted_grade_entries = Object.entries(grade_counts).sort((entry_a, entry_b) => {
				const count_diff = entry_b[1] - entry_a[1];
				if(count_diff !== 0) return count_diff;
				return sortGradeLabels(entry_a[0], entry_b[0]);
			});
			if(sorted_grade_entries.length > 0) grade_map.set(`${teacher_id}`, sorted_grade_entries[0][0]);
		});

		return grade_map;
	}, [students, homeroomGradeGroups]);

	const planner_cards = useMemo(() => {
		const cards = [];
		const specials_courses = courses.filter(course => `${course.is_special || '0'}` === '1');

		for(const course of specials_courses)
		{
			const course_id = `${course.course_id}`;
			const raw_course_name = (course.name) ? `${course.name}` : 'Untitled';
			const course_name = stripCourseLengthFromDisplayName(raw_course_name);
			const course_homerooms = (Array.isArray(course.course_homerooms)) ? course.course_homerooms.map(teacher_id => `${teacher_id}`) : [];
			const restrictions = (Array.isArray(course.day_period_restrictions)) ? course.day_period_restrictions : [];

			const parsed_num_times_needed = parseInt(course.num_times_needed, 10);
			const num_cards_per_homeroom = (!Number.isNaN(parsed_num_times_needed) && parsed_num_times_needed > 0) ? parsed_num_times_needed : 1;

			for(const homeroom_teacher_id of course_homerooms)
			{
				const homeroom_teacher_name = teacher_name_map.get(`${homeroom_teacher_id}`) || 'Unknown Homeroom Teacher';
				const grade_label = homeroom_teacher_grade_map.get(`${homeroom_teacher_id}`) || 'Unassigned';

				for(let i = 1; i <= num_cards_per_homeroom; i += 1)
				{
					const course_abbreviation = createCourseAbbreviation(course_name);
					const homeroom_teacher_abbreviation = teacher_abbrev_map.get(`${homeroom_teacher_id}`) || createAbbreviationFromDisplayName(homeroom_teacher_name);
					const tag_color = teacher_tag_color_map.get(`${homeroom_teacher_id}`) || DEFAULT_TEACHER_TAG_COLOR;

					cards.push({
						card_id: `${course_id}__${homeroom_teacher_id}__${i}`,
						course_id,
						course_name,
						course_abbrev: course_abbreviation || course_name,
						homeroom_teacher_id: `${homeroom_teacher_id}`,
						homeroom_teacher_name,
						homeroom_teacher_abbrev: homeroom_teacher_abbreviation || homeroom_teacher_name,
						tag_color,
						grade_label,
						instance_index: i,
						total_instances: num_cards_per_homeroom,
						day_period_restrictions: restrictions
					});
				}
			}
		}

		return cards.sort((card_a, card_b) => {
			const grade_sort = sortGradeLabels(card_a.grade_label, card_b.grade_label);
			if(grade_sort !== 0) return grade_sort;

			const teacher_sort = `${card_a.homeroom_teacher_name}`.localeCompare(`${card_b.homeroom_teacher_name}`);
			if(teacher_sort !== 0) return teacher_sort;

			const course_sort = `${card_a.course_name}`.localeCompare(`${card_b.course_name}`);
			if(course_sort !== 0) return course_sort;

			return card_a.instance_index - card_b.instance_index;
		});
	}, [courses, teacher_name_map, teacher_abbrev_map, teacher_tag_color_map, homeroom_teacher_grade_map]);

	const planner_card_map = useMemo(() => {
		return new Map(planner_cards.map(card => [card.card_id, card]));
	}, [planner_cards]);

	useEffect(() => {
		const valid_card_ids = new Set(planner_cards.map(card => card.card_id));
		setCardPlacements((previous_placements) => {
			let changed = false;
			const next_placements = {};

			Object.keys(previous_placements).forEach((card_id) => {
				if(!valid_card_ids.has(card_id))
				{
					changed = true;
					return;
				}
				next_placements[card_id] = previous_placements[card_id];
			});

			return changed ? next_placements : previous_placements;
		});
	}, [planner_cards]);

	useEffect(() => {
		const valid_card_ids = new Set(planner_cards.map(card => card.card_id));
		setUnassignedPlannerCardIDs((previous_ids) => {
			let changed = false;
			const next_ids = {};

			Object.keys(previous_ids).forEach((card_id) => {
				if(!valid_card_ids.has(card_id))
				{
					changed = true;
					return;
				}
				next_ids[card_id] = true;
			});

			return changed ? next_ids : previous_ids;
		});
	}, [planner_cards]);

	useEffect(() => {
		const valid_card_ids = new Set(planner_cards.map(card => card.card_id));
		setPersistedPlannerBlockIDs((previous_map) => {
			let changed = false;
			const next_map = {};

			Object.keys(previous_map).forEach((card_id) => {
				if(!valid_card_ids.has(card_id))
				{
					changed = true;
					return;
				}
				next_map[card_id] = previous_map[card_id];
			});

			return changed ? next_map : previous_map;
		});
	}, [planner_cards]);

	useEffect(() => {
		const valid_existing_ids = new Set(Object.keys(existing_block_item_map));

		setMovedExistingPlacements((previous_placements) => {
			let changed = false;
			const next_placements = {};

			Object.keys(previous_placements).forEach((existing_id) => {
				if(!valid_existing_ids.has(existing_id))
				{
					changed = true;
					return;
				}
				next_placements[existing_id] = previous_placements[existing_id];
			});

			return changed ? next_placements : previous_placements;
		});

		setUnassignedExistingIDs((previous_ids) => {
			let changed = false;
			const next_ids = {};

			Object.keys(previous_ids).forEach((existing_id) => {
				if(!valid_existing_ids.has(existing_id))
				{
					changed = true;
					return;
				}
				next_ids[existing_id] = true;
			});

			return changed ? next_ids : previous_ids;
		});
	}, [existing_block_item_map]);

	const unplaced_cards_by_homeroom = useMemo(() => {
		const results = {};
		const requirement_cards_by_key = {};
		const existing_placed_counts_by_key = {};
		const planner_placed_counts_by_key = {};

		planner_cards.forEach((card) => {
			const teacher_id = `${card.homeroom_teacher_id || ''}`.trim();
			const course_id = `${card.course_id || ''}`.trim();
			if(!teacher_id || !course_id) return;
			const requirement_key = `${teacher_id}__${course_id}`;
			if(!(requirement_key in requirement_cards_by_key)) requirement_cards_by_key[requirement_key] = [];
			requirement_cards_by_key[requirement_key].push(card);
		});

		specials_blocks.forEach((block_info) => {
			if(`${block_info?.is_special || '0'}` !== '1') return;

			const block_id = `${block_info?.block_id || ''}`.trim();
			if(!block_id || unassigned_existing_block_id_set.has(block_id)) return;

			const teacher_id = `${block_info?.homeroom_teacher_id || ''}`.trim();
			const course_id = `${block_info?.course_id || ''}`.trim();
			if(!teacher_id || !course_id) return;

			const requirement_key = `${teacher_id}__${course_id}`;
			if(!(requirement_key in existing_placed_counts_by_key)) existing_placed_counts_by_key[requirement_key] = 0;
			existing_placed_counts_by_key[requirement_key] += 1;
		});

		Object.keys(cardPlacements).forEach((card_id) => {
			if(card_id in unassignedPlannerCardIDs) return;
			const card_info = planner_card_map.get(card_id);
			if(!card_info) return;

			const teacher_id = `${card_info.homeroom_teacher_id || ''}`.trim();
			const course_id = `${card_info.course_id || ''}`.trim();
			if(!teacher_id || !course_id) return;

			const requirement_key = `${teacher_id}__${course_id}`;
			if(!(requirement_key in planner_placed_counts_by_key)) planner_placed_counts_by_key[requirement_key] = 0;
			planner_placed_counts_by_key[requirement_key] += 1;
		});

		Object.keys(requirement_cards_by_key).forEach((requirement_key) => {
			const requirement_cards = requirement_cards_by_key[requirement_key] || [];
			if(requirement_cards.length === 0) return;

			const existing_placed_count = existing_placed_counts_by_key[requirement_key] || 0;
			const planner_placed_count = planner_placed_counts_by_key[requirement_key] || 0;
			const total_required_count = requirement_cards.length;
			const total_placed_count = existing_placed_count + planner_placed_count;
			const remaining_needed_count = Math.max(0, total_required_count - total_placed_count);
			if(remaining_needed_count <= 0) return;

			const candidate_cards = requirement_cards
				.filter((card) => !(card.card_id in cardPlacements) || (card.card_id in unassignedPlannerCardIDs))
				.sort((card_a, card_b) => card_a.instance_index - card_b.instance_index);

			candidate_cards.slice(0, remaining_needed_count).forEach((card) => {
				const teacher_id = `${card.homeroom_teacher_id || ''}`.trim();
				if(!teacher_id) return;
				if(!(teacher_id in results)) results[teacher_id] = [];
				results[teacher_id].push(card);
			});
		});

		return results;
	}, [planner_cards, cardPlacements, unassignedPlannerCardIDs, specials_blocks, unassigned_existing_block_id_set, planner_card_map]);

	const homeroom_requirements_by_grade = useMemo(() => {
		const teachers_with_requirements = {};
		for(const card of planner_cards)
		{
			const homeroom_teacher_id = card.homeroom_teacher_id;
			if(!(homeroom_teacher_id in teachers_with_requirements))
				{
					teachers_with_requirements[homeroom_teacher_id] = {
						teacher_id: homeroom_teacher_id,
						teacher_name: card.homeroom_teacher_name,
						grade_label: card.grade_label,
						tag_color: card.tag_color || teacher_tag_color_map.get(homeroom_teacher_id) || DEFAULT_TEACHER_TAG_COLOR
					};
				}
			}

		const grouped = {};
		Object.values(teachers_with_requirements).forEach((teacher_info) => {
			const grade_label = teacher_info.grade_label || 'Unassigned';
			if(!(grade_label in grouped)) grouped[grade_label] = [];

			grouped[grade_label].push({
				...teacher_info,
				unplaced_cards: unplaced_cards_by_homeroom[teacher_info.teacher_id] || []
				});
			});

			const grade_labels = Object.keys(grouped).sort(sortGradeLabels);
			return grade_labels.map((grade_label) => {
				const teachers_for_grade = grouped[grade_label].sort((teacher_a, teacher_b) => `${teacher_a.teacher_name}`.localeCompare(`${teacher_b.teacher_name}`));
				return {grade_label, teachers: teachers_for_grade};
			});
	}, [planner_cards, unplaced_cards_by_homeroom, teacher_tag_color_map]);

	const homeroom_teacher_ids_needing_any_special = useMemo(() => {
		const teacher_ids = new Set();
		planner_cards.forEach((card_info) => {
			const teacher_id = `${card_info.homeroom_teacher_id || ''}`.trim();
			if(teacher_id) teacher_ids.add(teacher_id);
		});
		specials_blocks.forEach((block_info) => {
			const teacher_id = `${block_info.homeroom_teacher_id || ''}`.trim();
			if(teacher_id) teacher_ids.add(teacher_id);
		});

		const sorted_ids = [...teacher_ids];
		sorted_ids.sort((teacher_id_a, teacher_id_b) => {
			const teacher_name_a = teacher_name_map.get(teacher_id_a) || `Teacher ${teacher_id_a}`;
			const teacher_name_b = teacher_name_map.get(teacher_id_b) || `Teacher ${teacher_id_b}`;
			return teacher_name_a.localeCompare(teacher_name_b);
		});

		return sorted_ids;
	}, [planner_cards, specials_blocks, teacher_name_map]);

	const grid_specials_teacher_filter_options = useMemo(() => {
		return teacher_header_meta.map((teacher_meta) => ({
			value: `${teacher_meta.teacher_id || ''}`,
			display: teacher_meta.full_name || teacher_meta.code || 'Unknown Specials Teacher'
		}));
	}, [teacher_header_meta]);

	useEffect(() => {
		const valid_teacher_ids = new Set(teacher_header_meta.map((teacher_meta) => `${teacher_meta.teacher_id || ''}`.trim()).filter(Boolean));
		setSelectedGridSpecialsTeacherIDs((previous_ids) => previous_ids.filter((teacher_id) => valid_teacher_ids.has(`${teacher_id || ''}`.trim())));
	}, [teacher_header_meta]);

	const selected_teacher_filters = useMemo(() => {
		return new Set((plannerFilterOptions.teachers || []).filter(option => option.selected).map(option => `${option.value}`));
	}, [plannerFilterOptions]);

	const selected_special_filters = useMemo(() => {
		return new Set((plannerFilterOptions.specials || []).filter(option => option.selected).map(option => `${option.value}`));
	}, [plannerFilterOptions]);

	const planner_grade_filter_options = useMemo(() => {
		const grade_values = homeroom_requirements_by_grade
			.map((grade_group) => `${grade_group.grade_label || ''}`.trim())
			.filter(Boolean)
			.sort(sortGradeLabels);

		return [
			{value:'', display:'All Grades'},
			...grade_values.map((grade_value) => ({
				value: grade_value,
				display: formatGradeLabelDisplay(grade_value)
			}))
		];
	}, [homeroom_requirements_by_grade]);

	const planner_grade_filtered_requirements_by_grade = useMemo(() => {
		if(!selectedPlannerGradeFilter) return homeroom_requirements_by_grade;
		return homeroom_requirements_by_grade.filter((grade_group) => `${grade_group.grade_label || ''}`.trim() === selectedPlannerGradeFilter);
	}, [homeroom_requirements_by_grade, selectedPlannerGradeFilter]);

	useEffect(() => {
		if(!selectedPlannerGradeFilter) return;
		const valid_grade_values = new Set(planner_grade_filter_options.map((option) => `${option.value || ''}`));
		if(valid_grade_values.has(selectedPlannerGradeFilter)) return;
		setSelectedPlannerGradeFilter('');
	}, [selectedPlannerGradeFilter, planner_grade_filter_options]);

	useEffect(() => {
		const teacher_map = new Map();
		const special_map = new Map();

		planner_grade_filtered_requirements_by_grade.forEach((grade_group) => {
			(grade_group.teachers || []).forEach((teacher_info) => {
				const teacher_id = `${teacher_info.teacher_id || ''}`.trim();
				const teacher_name = `${teacher_info.teacher_name || ''}`.trim();
				const unplaced_cards = Array.isArray(teacher_info.unplaced_cards) ? teacher_info.unplaced_cards : [];

				const teacher_matches_special_selection = (selected_special_filters.size === 0) || unplaced_cards.some((card_info) => {
					const special_filter_value = getPlannerSpecialFilterValue(card_info);
					return special_filter_value && selected_special_filters.has(`${special_filter_value}`);
				});

				if(teacher_id && teacher_matches_special_selection && !teacher_map.has(teacher_id))
				{
					teacher_map.set(teacher_id, {value:teacher_id, display:teacher_name || `Teacher ${teacher_id}`, selected:false});
				}

				if(selected_teacher_filters.size > 0 && !selected_teacher_filters.has(teacher_id)) return;

				unplaced_cards.forEach((card_info) => {
					const special_value = getPlannerSpecialFilterValue(card_info);
					const special_display = getPlannerSpecialFilterDisplay(card_info);
					if(!special_value || !special_display || special_map.has(special_value)) return;
					special_map.set(special_value, {value:special_value, display:special_display, selected:false});
				});
			});
		});

		const teacher_options = [...teacher_map.values()].sort((teacher_a, teacher_b) => teacher_a.display.localeCompare(teacher_b.display));
		const special_options = [...special_map.values()].sort((special_a, special_b) => special_a.display.localeCompare(special_b.display));

		setPlannerFilterOptions((previous_options) => {
			const selected_teacher_values = new Set((previous_options.teachers || []).filter(option => option.selected).map(option => option.value));
			const selected_special_values = new Set((previous_options.specials || []).filter(option => option.selected).map(option => option.value));
			const next_teacher_options = teacher_options.map(option => ({...option, selected:selected_teacher_values.has(option.value)}));
			const next_special_options = special_options.map(option => ({...option, selected:selected_special_values.has(option.value)}));
			const previous_teacher_options = previous_options.teachers || [];
			const previous_special_options = previous_options.specials || [];

			const teacher_options_unchanged = previous_teacher_options.length === next_teacher_options.length && previous_teacher_options.every((option, index) => {
				const next_option = next_teacher_options[index];
				return next_option && option.value === next_option.value && option.display === next_option.display && option.selected === next_option.selected;
			});

			const special_options_unchanged = previous_special_options.length === next_special_options.length && previous_special_options.every((option, index) => {
				const next_option = next_special_options[index];
				return next_option && option.value === next_option.value && option.display === next_option.display && option.selected === next_option.selected;
			});

			if(teacher_options_unchanged && special_options_unchanged) return previous_options;

			return {
				teachers: next_teacher_options,
				specials: next_special_options
			};
		});
	}, [planner_grade_filtered_requirements_by_grade, selected_teacher_filters, selected_special_filters]);

	const filtered_homeroom_requirements_by_grade = useMemo(() => {
		const no_option_filters_selected = !selectedPlannerGradeFilter && selected_teacher_filters.size === 0 && selected_special_filters.size === 0;
		if(no_option_filters_selected && !hideCompletedTeachers) return homeroom_requirements_by_grade;

		return planner_grade_filtered_requirements_by_grade.reduce((grade_results, grade_group) => {
			const teachers = (grade_group.teachers || []).reduce((teacher_results, teacher_info) => {
				const teacher_id = `${teacher_info.teacher_id || ''}`.trim();
				const teacher_match = (selected_teacher_filters.size === 0 || selected_teacher_filters.has(teacher_id));
				if(!teacher_match) return teacher_results;

				const unplaced_cards = Array.isArray(teacher_info.unplaced_cards) ? teacher_info.unplaced_cards : [];
				const filtered_cards = (selected_special_filters.size === 0) ? unplaced_cards : unplaced_cards.filter((card_info) => {
					const special_filter_value = getPlannerSpecialFilterValue(card_info);
					return (special_filter_value) ? selected_special_filters.has(`${special_filter_value}`) : false;
				});

				if(selected_special_filters.size > 0 && filtered_cards.length === 0) return teacher_results;
				if(hideCompletedTeachers && filtered_cards.length === 0) return teacher_results;
				teacher_results.push({...teacher_info, unplaced_cards: filtered_cards});
				return teacher_results;
			}, []);

			if(teachers.length > 0) grade_results.push({...grade_group, teachers});
			return grade_results;
		}, []);
	}, [homeroom_requirements_by_grade, planner_grade_filtered_requirements_by_grade, selectedPlannerGradeFilter, selected_teacher_filters, selected_special_filters, hideCompletedTeachers]);

	const all_homerooms_have_specials_placed = useMemo(() => {
		if(homeroom_requirements_by_grade.length === 0) return false;
		return homeroom_requirements_by_grade.every((grade_group) => {
			const teachers_for_grade = Array.isArray(grade_group.teachers) ? grade_group.teachers : [];
			return teachers_for_grade.every((teacher_info) => {
				const unplaced_cards = Array.isArray(teacher_info.unplaced_cards) ? teacher_info.unplaced_cards : [];
				return unplaced_cards.length === 0;
			});
		});
	}, [homeroom_requirements_by_grade]);

	const selected_planner_filters = useMemo(() => {
		return Object.keys(plannerFilterOptions).reduce((results, filter_title) => {
			const current_options = plannerFilterOptions[filter_title] || [];
			current_options.forEach((option) => {
				if(!option.selected) return;
				results.push({filter_title, value:option.value, display:option.display});
			});
			return results;
		}, []);
	}, [plannerFilterOptions]);

	const updatePlannerFilterOption = (filter_title, option_index, selected) => {
		setPlannerFilterOptions((previous_options) => {
			const next_options = {...previous_options};
			const option_list = [...(next_options[filter_title] || [])];
			if(option_index < 0 || option_index >= option_list.length) return previous_options;
			option_list[option_index] = {...option_list[option_index], selected};
			next_options[filter_title] = option_list;
			return next_options;
		});
	};

	const updatePlannerOpenFilters = (filter_title, filter_options_open) => {
		setPlannerOpenFilterOptions((previous_open_filters) => {
			if(filter_options_open) return previous_open_filters.filter(filter => filter !== filter_title);
			return [...previous_open_filters, filter_title];
		});
	};

	const toggleGridSpecialsTeacherFilterValue = (teacher_id) => {
		const normalized_teacher_id = `${teacher_id || ''}`.trim();
		if(!normalized_teacher_id) return;
		setSelectedGridSpecialsTeacherIDs((previous_ids) => {
			const already_selected = previous_ids.includes(normalized_teacher_id);
			if(already_selected) return previous_ids.filter((id) => id !== normalized_teacher_id);
			return [...previous_ids, normalized_teacher_id];
		});
	};

	const toggleGridHomeroomTeacherFilterValue = (teacher_id) => {
		const normalized_teacher_id = `${teacher_id || ''}`.trim();
		if(!normalized_teacher_id) return;
		setSelectedGridHomeroomTeacherIDs((previous_ids) => {
			const already_selected = previous_ids.includes(normalized_teacher_id);
			if(already_selected) return previous_ids.filter((id) => id !== normalized_teacher_id);
			return [...previous_ids, normalized_teacher_id];
		});
	};

	const resetAutoPlacerProgress = () => {
		setAutoPlacerProgress(DEFAULT_AUTO_PLACER_PROGRESS);
	};

	const updateAutoPlacerProgress = async ({ percent = 0, phase_label = '', status_line = '', delay_ms = 70 }) => {
		setAutoPlacerProgress((previous_progress) => {
			const next_step_log = [...(previous_progress.step_log || [])];
			if(status_line)
			{
				const last_logged_step = next_step_log[next_step_log.length - 1];
				if(last_logged_step !== status_line) next_step_log.push(status_line);
			}

			return {
				visible: true,
				percent: Math.max(0, Math.min(100, percent)),
				phase_label,
				status_line,
				step_log: next_step_log.slice(-6)
			};
		});

		if(delay_ms > 0) await sleep(delay_ms);
	};

	const resetClearAllProgress = () => {
		setClearAllProgress(DEFAULT_CLEAR_ALL_PROGRESS);
	};

	const updateClearAllProgress = async ({ percent = 0, phase_label = '', status_line = '', delay_ms = 60 }) => {
		setClearAllProgress({
			visible: true,
			percent: Math.max(0, Math.min(100, percent)),
			phase_label,
			status_line
		});

		if(delay_ms > 0) await sleep(delay_ms);
	};

	const runAutoPlacerPlaceholder = async (replace_existing = true) => {
		if(isRunningAutoPlacer || isClearingAllSpecials) return;
		setGridActionsVisible(false);

		if(!schedule_version_id)
		{
			await swal({
				title: 'Cannot Run Auto Placer',
				icon: 'warning',
				buttons: {
					confirm: {
						text: 'Got it',
						value: true,
						visible: true,
						className: 'blue-btn'
					}
				},
				content: (
					<div>
						<p>There is no active schedule version available for special placement.</p>
					</div>
				)
			});
			return;
		}

		if(period_rows.length === 0 || teacher_header_meta.length === 0)
		{
			await swal({
				title: 'Cannot Run Auto Placer',
				icon: 'warning',
				buttons: {
					confirm: {
						text: 'Got it',
						value: true,
						visible: true,
						className: 'blue-btn'
					}
				},
				content: (
					<div>
						<p>Add specials periods and specials teachers before running Auto Placer.</p>
					</div>
				)
			});
			return;
		}

		setIsRunningAutoPlacer(true);
		resetAutoPlacerProgress();

		try
		{
			await updateAutoPlacerProgress({
				percent: 8,
				phase_label: 'Prepare',
				status_line: 'Preparing specials scheduling request...'
			});

			const should_replace_existing = (typeof replace_existing === 'boolean') ? replace_existing : true;
			const data = {
				schedule_version_id,
				replace: should_replace_existing
			};
			const url = '/elementary/schedule-specials';
			const myInit = {
				response: true,
				body: JSON.stringify(data),
			};
			const api_names = [process.env.REACT_APP_ELEM_ENDPOINT_NAME, process.env.REACT_APP_ENDPOINT_NAME].filter(Boolean);
			if(api_names.length === 0) throw new Error('Missing API endpoint configuration for specials scheduling');

			await updateAutoPlacerProgress({
				percent: 22,
				phase_label: 'Submit Job',
				status_line: 'Sending the schedule request to the backend scheduler...'
			});

			let response = null;
			let last_error = null;
			for(let i = 0; i < api_names.length; i += 1)
			{
				try
				{
					response = await API.post(api_names[i], url, myInit);
					last_error = null;
					break;
				}
				catch(error)
				{
					last_error = error;
				}
			}
			if(last_error) throw last_error;

			await updateAutoPlacerProgress({
				percent: 38,
				phase_label: 'Queue Job',
				status_line: 'Backend scheduler accepted the request. Looking for the active job...'
			});

			const current_data_version_id = `${schoolInfo?.current_data_version_id || ''}`.trim();
			const current_schedule_year_id = `${schoolInfo?.current_schedule_year_id || ''}`.trim();
			const response_progress_id = `${response?.data?.progress_id || response?.data?.data?.progress_id || response?.progress_id || ''}`.trim();
			let scheduler_event = null;

			if(school_id && current_data_version_id && current_schedule_year_id)
			{
				const file_upload = new FileUpload(current_data_version_id, schedule_version_id, school_id);
				const running_processes = await file_upload.getSchoolProcesses(current_schedule_year_id);
				const matching_processes = (Array.isArray(running_processes) ? running_processes : []).filter((process_info) => {
					return `${process_info?.schedule_version_id || ''}`.trim() === schedule_version_id && `${process_info?.progress_id || ''}`.trim();
				});
				const scheduler_process = matching_processes.find((process_info) => `${process_info?.progress_id || ''}`.trim() === response_progress_id)
					|| matching_processes.find((process_info) => `${process_info?.process_type || ''}`.toLowerCase().includes('special'))
					|| matching_processes.find((process_info) => !process_info?.is_done)
					|| null;
				const progress_id = `${scheduler_process?.progress_id || response_progress_id || ''}`.trim();

				if(progress_id)
				{
					await updateAutoPlacerProgress({
						percent: 58,
						phase_label: 'Run Scheduler',
						status_line: 'Scheduler job is running. Waiting for backend progress updates...'
					});

					scheduler_event = await new Promise((resolve, reject) => {
						let settled = false;
						const finish = (payload) => {
							if(settled) return;
							settled = true;
							resolve(payload);
						};

						file_upload.checkUploading(school_id, progress_id, (event) => {
							finish(event);
						}).catch((error) => {
							if(settled) return;
							settled = true;
							reject(error);
						});

						setTimeout(async () => {
							if(settled) return;
							try
							{
								const refreshed_processes = await file_upload.getSchoolProcesses(current_schedule_year_id);
								const refreshed_process = (Array.isArray(refreshed_processes) ? refreshed_processes : []).find((process_info) => `${process_info?.progress_id || ''}`.trim() === progress_id);
								if(!refreshed_process) return;
								if(refreshed_process.is_done || refreshed_process.failure || refreshed_process.has_feedback)
								{
									file_upload.cancelCheck();
									finish({
										has_started: Boolean(refreshed_process.has_started),
										done: Boolean(refreshed_process.is_done),
										failure: Boolean(refreshed_process.failure),
										has_feedback: Boolean(refreshed_process.has_feedback),
										progress: refreshed_process.progress ?? 0
									});
								}
							}
							catch(error)
							{
								if(settled) return;
								settled = true;
								reject(error);
							}
						}, 500);
					});
				}
			}

			if(scheduler_event?.failure)
			{
				throw new Error('The backend specials scheduler reported a failure.');
			}

			await updateAutoPlacerProgress({
				percent: 84,
				phase_label: 'Refresh',
				status_line: 'Specials scheduling finished. Loading the saved placements...'
			});

			await refreshExistingBlocksFromBackend({ resetPlannerState:true });

			await updateAutoPlacerProgress({
				percent: 100,
				phase_label: 'Complete',
				status_line: 'Saved specials placements loaded.',
				delay_ms: 120
			});
		}
		catch(error)
		{
			console.log(error?.response || error);
			await swal({
				title: 'Auto Placer Failed',
				icon: 'error',
				buttons: {
					confirm: {
						text: 'Got it',
						value: true,
						visible: true,
						className: 'blue-btn'
					}
				},
				content: (
					<div>
						<p>There was an error while running the backend specials scheduler. Please try again.</p>
					</div>
				)
			});
		}
		finally
		{
			setIsRunningAutoPlacer(false);
			resetAutoPlacerProgress();
		}
	};

	const toggleGridActionsMenu = () => {
		setGridActionsVisible((previous_visible) => !previous_visible);
		setGridSpecialsTeacherFilterVisible(false);
		setGridHomeroomTeacherFilterVisible(false);
	};

	const toggleGridSpecialsTeacherFilterMenu = () => {
		setGridSpecialsTeacherFilterVisible((previous_visible) => !previous_visible);
		setGridActionsVisible(false);
		setGridHomeroomTeacherFilterVisible(false);
	};

	const toggleGridHomeroomTeacherFilterMenu = () => {
		setGridHomeroomTeacherFilterVisible((previous_visible) => !previous_visible);
		setGridActionsVisible(false);
		setGridSpecialsTeacherFilterVisible(false);
	};

	const toggleLegendVisibility = () => {
		setLegendVisible((previous_visible) => !previous_visible);
	};

	const homeroom_teacher_tag_colors_in_use = useMemo(() => {
		const color_map = {};

		teacher_tag_color_map.forEach((tag_color, teacher_id) => {
			const normalized_teacher_id = `${teacher_id || ''}`.trim();
			if(!normalized_teacher_id) return;
			color_map[normalized_teacher_id] = normalizeTeacherTagColorClass(tag_color || DEFAULT_TEACHER_TAG_COLOR);
		});

		planner_cards.forEach((card_info) => {
			const teacher_id = `${card_info.homeroom_teacher_id || ''}`.trim();
			if(!teacher_id) return;
			if(!(teacher_id in color_map)) color_map[teacher_id] = normalizeTeacherTagColorClass(card_info.tag_color || teacher_tag_color_map.get(teacher_id) || DEFAULT_TEACHER_TAG_COLOR);
		});

		Object.values(existing_block_item_map).forEach((existing_item) => {
			const teacher_id = `${existing_item.homeroom_teacher_id || ''}`.trim();
			if(!teacher_id) return;
			if(!(teacher_id in color_map)) color_map[teacher_id] = normalizeTeacherTagColorClass(existing_item.tag_color || teacher_tag_color_map.get(teacher_id) || DEFAULT_TEACHER_TAG_COLOR);
		});

		return color_map;
	}, [planner_cards, existing_block_item_map, teacher_tag_color_map]);

	const placed_cards_lookup = useMemo(() => {
		const lookup = {};
		Object.entries(cardPlacements).forEach(([card_id, placement]) => {
			if(card_id in unassignedPlannerCardIDs) return;
			const card_info = planner_card_map.get(card_id);
			if(!card_info || !placement) return;

			const key = `${placement.period_row_id}__${placement.day_number}__${placement.specials_teacher_id}`;
			if(!(key in lookup)) lookup[key] = [];
			lookup[key].push(card_info);
		});

		return lookup;
	}, [cardPlacements, planner_card_map, unassignedPlannerCardIDs]);

	const placed_grid_homeroom_teacher_ids = useMemo(() => {
		const teacher_ids = new Set();

		Object.values(existing_cell_blocks_lookup || {}).forEach((cell_blocks) => {
			(cell_blocks || []).forEach((block_info) => {
				const teacher_id = `${block_info?.homeroom_teacher_id || ''}`.trim();
				if(teacher_id) teacher_ids.add(teacher_id);
			});
		});

		Object.values(placed_cards_lookup || {}).forEach((placed_cards) => {
			(placed_cards || []).forEach((card_info) => {
				const teacher_id = `${card_info?.homeroom_teacher_id || ''}`.trim();
				if(teacher_id) teacher_ids.add(teacher_id);
			});
		});

		return [...teacher_ids].sort((teacher_id_a, teacher_id_b) => {
			const teacher_name_a = teacher_name_map.get(teacher_id_a) || `Teacher ${teacher_id_a}`;
			const teacher_name_b = teacher_name_map.get(teacher_id_b) || `Teacher ${teacher_id_b}`;
			return teacher_name_a.localeCompare(teacher_name_b);
		});
	}, [existing_cell_blocks_lookup, placed_cards_lookup, teacher_name_map]);

	const grid_homeroom_teacher_filter_options = useMemo(() => {
		return placed_grid_homeroom_teacher_ids.map((teacher_id) => ({
			value: `${teacher_id}`,
			display: teacher_name_map.get(`${teacher_id}`) || `Teacher ${teacher_id}`
		}));
	}, [placed_grid_homeroom_teacher_ids, teacher_name_map]);

	const grid_homeroom_teacher_grouped_filter_options = useMemo(() => {
		const grouped_options = {};

		placed_grid_homeroom_teacher_ids.forEach((teacher_id) => {
			const normalized_teacher_id = `${teacher_id || ''}`.trim();
			if(!normalized_teacher_id) return;

			const normalized_grade_label = normalizeGradeLabel(homeroom_teacher_grade_map.get(normalized_teacher_id) || 'Unassigned') || 'Unassigned';
			if(!(normalized_grade_label in grouped_options)) grouped_options[normalized_grade_label] = [];

			grouped_options[normalized_grade_label].push({
				value: normalized_teacher_id,
				display: teacher_name_map.get(normalized_teacher_id) || `Teacher ${normalized_teacher_id}`
			});
		});

		const sorted_grade_labels = Object.keys(grouped_options).sort(sortGradeLabels);
		const grouped_filter_options = [];

		sorted_grade_labels.forEach((grade_label) => {
			const grade_display = formatGradeLabelDisplay(grade_label) || `${grade_label}`;
			grouped_filter_options.push({
				option_is_group_label: true,
				value: `group-${grade_label}`,
				display: grade_display
			});

			const sorted_teacher_options = grouped_options[grade_label].sort((option_a, option_b) => `${option_a.display || ''}`.localeCompare(`${option_b.display || ''}`));
			sorted_teacher_options.forEach((option_info) => grouped_filter_options.push(option_info));
		});

		return grouped_filter_options;
	}, [placed_grid_homeroom_teacher_ids, homeroom_teacher_grade_map, teacher_name_map]);

	const homeroom_day_conflict_meta = useMemo(() => {
		const assignment_rows = [];
		const seen_existing_assignments = new Set();
		const seen_planner_assignments = new Set();

		period_rows.forEach((period) => {
			const period_row_id = `${period._specials_review_row_id || ''}`.trim();
			if(!period_row_id) return;

			cycle_days.forEach((day_number) => {
				teacher_header_meta.forEach((teacher_meta) => {
					const teacher_id = `${teacher_meta.teacher_id || ''}`.trim();
					if(!teacher_id) return;

					const cell_key = `${period_row_id}__${day_number}__${teacher_id}`;
					const existing_cell_blocks = existing_cell_blocks_lookup[cell_key] || [];
					const placed_cards = placed_cards_lookup[cell_key] || [];

					existing_cell_blocks.forEach((block_info) => {
						const normalized_homeroom_teacher_id = `${block_info?.homeroom_teacher_id || ''}`.trim();
						if(!normalized_homeroom_teacher_id) return;

						const existing_unique_id = `${block_info?.block_id || block_info?.existing_instance_id || ''}`.trim();
						const seen_key = `${day_number}__${period_row_id}__${existing_unique_id}`;
						if(!existing_unique_id || seen_existing_assignments.has(seen_key)) return;
						seen_existing_assignments.add(seen_key);

						assignment_rows.push({
							day_number: `${day_number}`,
							period_row_id,
							assignment_key: `existing:${existing_unique_id}`,
							homeroom_teacher_id: normalized_homeroom_teacher_id,
							homeroom_teacher_name: `${block_info?.homeroom_teacher_name || teacher_name_map.get(normalized_homeroom_teacher_id) || `Teacher ${normalized_homeroom_teacher_id}`}`.trim()
						});
					});

					placed_cards.forEach((card_info) => {
						const normalized_homeroom_teacher_id = `${card_info?.homeroom_teacher_id || ''}`.trim();
						if(!normalized_homeroom_teacher_id) return;

						const planner_unique_id = `${card_info?.card_id || ''}`.trim();
						const seen_key = `${day_number}__${period_row_id}__${planner_unique_id}`;
						if(!planner_unique_id || seen_planner_assignments.has(seen_key)) return;
						seen_planner_assignments.add(seen_key);

						assignment_rows.push({
							day_number: `${day_number}`,
							period_row_id,
							assignment_key: `planner:${planner_unique_id}`,
							homeroom_teacher_id: normalized_homeroom_teacher_id,
							homeroom_teacher_name: `${card_info?.homeroom_teacher_name || teacher_name_map.get(normalized_homeroom_teacher_id) || `Teacher ${normalized_homeroom_teacher_id}`}`.trim()
						});
					});
				});
			});
		});

		const count_by_day_homeroom = {};
		const seen_assignment_keys_by_bucket = {};
		assignment_rows.forEach((assignment_info) => {
			const bucket_key = `${assignment_info.day_number}__${assignment_info.homeroom_teacher_id}`;
			const assignment_key = `${assignment_info.assignment_key || ''}`.trim();
			if(!assignment_key) return;

			if(!(bucket_key in seen_assignment_keys_by_bucket)) seen_assignment_keys_by_bucket[bucket_key] = new Set();
			if(seen_assignment_keys_by_bucket[bucket_key].has(assignment_key)) return;
			seen_assignment_keys_by_bucket[bucket_key].add(assignment_key);

			if(!(bucket_key in count_by_day_homeroom)) count_by_day_homeroom[bucket_key] = 0;
			count_by_day_homeroom[bucket_key] += 1;
		});

		const conflicting_day_homeroom_keys = new Set(Object.keys(count_by_day_homeroom).filter((bucket_key) => (count_by_day_homeroom[bucket_key] || 0) > 1));
		const row_day_reasons = {};
		const row_reasons = {};

		assignment_rows.forEach((assignment_info) => {
			const bucket_key = `${assignment_info.day_number}__${assignment_info.homeroom_teacher_id}`;
			if(!conflicting_day_homeroom_keys.has(bucket_key)) return;

			const teacher_name = assignment_info.homeroom_teacher_name || `Teacher ${assignment_info.homeroom_teacher_id}`;
			const reason_message = `${teacher_name} has more than one special on this day (Day ${assignment_info.day_number}).`;
			const row_day_key = `${assignment_info.period_row_id}__${assignment_info.day_number}`;
			if(!(row_day_key in row_day_reasons)) row_day_reasons[row_day_key] = new Set();
			if(!(assignment_info.period_row_id in row_reasons)) row_reasons[assignment_info.period_row_id] = new Set();

			row_day_reasons[row_day_key].add(reason_message);
			row_reasons[assignment_info.period_row_id].add(reason_message);
		});

		const serialized_row_day_reasons = {};
		Object.keys(row_day_reasons).forEach((row_day_key) => {
			serialized_row_day_reasons[row_day_key] = [...row_day_reasons[row_day_key]];
		});

		const serialized_row_reasons = {};
		Object.keys(row_reasons).forEach((period_row_id) => {
			serialized_row_reasons[period_row_id] = [...row_reasons[period_row_id]];
		});

		return {
			conflicting_day_homeroom_keys,
			row_day_reasons: serialized_row_day_reasons,
			row_reasons: serialized_row_reasons
		};
	}, [period_rows, cycle_days, teacher_header_meta, existing_cell_blocks_lookup, placed_cards_lookup, teacher_name_map]);

	const total_blocks_by_day_teacher = useMemo(() => {
		const totals = {};
		const seen_existing_ids = {};
		const seen_planner_ids = {};

		cycle_days.forEach((day_number) => {
			teacher_header_meta.forEach((teacher_meta) => {
				const teacher_id = `${teacher_meta.teacher_id || ''}`.trim();
				if(!teacher_id) return;
				const bucket_key = `${day_number}__${teacher_id}`;
				totals[bucket_key] = 0;
				seen_existing_ids[bucket_key] = new Set();
				seen_planner_ids[bucket_key] = new Set();
			});
		});

		period_rows.forEach((period) => {
			const period_row_id = `${period._specials_review_row_id || ''}`;
			if(!period_row_id) return;

			cycle_days.forEach((day_number) => {
				teacher_header_meta.forEach((teacher_meta) => {
					const teacher_id = `${teacher_meta.teacher_id || ''}`.trim();
					if(!teacher_id) return;

					const bucket_key = `${day_number}__${teacher_id}`;
					const cell_key = `${period_row_id}__${day_number}__${teacher_id}`;
					const existing_cell_blocks = existing_cell_blocks_lookup[cell_key] || [];
					const placed_cards = placed_cards_lookup[cell_key] || [];

					existing_cell_blocks.forEach((block_info) => {
						const existing_unique_id = `${block_info?.block_id || block_info?.existing_instance_id || ''}`.trim();
						if(!existing_unique_id) return;
						if(seen_existing_ids[bucket_key].has(existing_unique_id)) return;
						seen_existing_ids[bucket_key].add(existing_unique_id);
						totals[bucket_key] += 1;
					});

					placed_cards.forEach((card_info) => {
						const planner_unique_id = `${card_info?.card_id || ''}`.trim();
						if(!planner_unique_id) return;
						if(seen_planner_ids[bucket_key].has(planner_unique_id)) return;
						seen_planner_ids[bucket_key].add(planner_unique_id);
						totals[bucket_key] += 1;
					});
				});
			});
		});

		return totals;
	}, [cycle_days, teacher_header_meta, period_rows, existing_cell_blocks_lookup, placed_cards_lookup]);

	/*
	 * Legacy frontend auto placer scoring helpers.
	 * Kept here as comments for reference while the backend scheduler handles auto placement.
	 *
	 * const calculateTeacherDayBalanceScore = (teacher_day_totals = {}) => {
	 * 	let total_score = 0;
	 *
	 * 	teacher_header_meta.forEach((teacher_meta) => {
	 * 		const teacher_id = `${teacher_meta.teacher_id || ''}`.trim();
	 * 		if(!teacher_id) return;
	 *
	 * 		let teacher_total = 0;
	 * 		cycle_days.forEach((day_number) => {
	 * 			teacher_total += teacher_day_totals[createTeacherDayKey(day_number, teacher_id)] || 0;
	 * 		});
	 *
	 * 		const teacher_average = (cycle_days.length > 0) ? (teacher_total / cycle_days.length) : 0;
	 * 		cycle_days.forEach((day_number) => {
	 * 			const day_total = teacher_day_totals[createTeacherDayKey(day_number, teacher_id)] || 0;
	 * 			total_score += Math.abs(day_total - teacher_average);
	 * 		});
	 * 	});
	 *
	 * 	return total_score;
	 * };
	 *
	 * const calculateTeacherDayBalancePercent = (teacher_day_totals = {}) => {
	 * 	const day_count = cycle_days.length;
	 * 	if(day_count <= 1) return 100;
	 *
	 * 	const raw_score = calculateTeacherDayBalanceScore(teacher_day_totals);
	 * 	let max_possible_score = 0;
	 *
	 * 	teacher_header_meta.forEach((teacher_meta) => {
	 * 		const teacher_id = `${teacher_meta.teacher_id || ''}`.trim();
	 * 		if(!teacher_id) return;
	 *
	 * 		let teacher_total = 0;
	 * 		cycle_days.forEach((day_number) => {
	 * 			teacher_total += teacher_day_totals[createTeacherDayKey(day_number, teacher_id)] || 0;
	 * 		});
	 *
	 * 		if(teacher_total <= 0) return;
	 * 		max_possible_score += (2 * teacher_total * (day_count - 1)) / day_count;
	 * 	});
	 *
	 * 	if(max_possible_score <= 0) return 100;
	 * 	const normalized_percent = (1 - (raw_score / max_possible_score)) * 100;
	 * 	return Math.max(0, Math.min(100, normalized_percent));
	 * };
	 */

	const isCardPlacementAllowed = (card_info, day_number, period_info, specials_teacher_id = '') => {
		if(!card_info || !period_info) return false;

		const period_days = (Array.isArray(period_info.days)) ? period_info.days.map(day => `${day}`) : [];
		const period_runs_this_day = period_days.includes(`${day_number}`);
		const is_special_period = `${period_info.is_special || '0'}` === '1';
		const restrictions = (Array.isArray(card_info.day_period_restrictions)) ? card_info.day_period_restrictions : [];

		const is_restricted = restrictions.some(restriction => {
			return `${restriction.day_number}` === `${day_number}` && `${restriction.period_id}` === `${period_info.period_id}`;
		});

		const normalized_course_id = `${card_info.course_id || ''}`.trim();
		const teacher_restriction_met = isTeacherAllowedForCourse(normalized_course_id, specials_teacher_id);

		return period_runs_this_day && is_special_period && !is_restricted && teacher_restriction_met;
	};

	const isTeacherAllowedForCourse = (course_id, specials_teacher_id = '') => {
		const normalized_specials_teacher_id = `${specials_teacher_id || ''}`.trim();
		const normalized_course_id = `${course_id || ''}`.trim();
		const allowed_teacher_ids = course_allowed_teacher_ids_map.get(normalized_course_id);
		return !normalized_specials_teacher_id || !allowed_teacher_ids || allowed_teacher_ids.size === 0 || allowed_teacher_ids.has(normalized_specials_teacher_id);
	};

	const syncExistingBlockDaysToBackend = async (existing_block_info = null, kept_block_days = []) => {
		if(!school_id || !schedule_version_id || !existing_block_info?.block_id) return false;

		const normalized_block_days = (Array.isArray(kept_block_days) ? kept_block_days : [])
			.map((block_day) => ({
				block_id: existing_block_info.block_id,
				block_day_id: block_day?.block_day_id || null,
				day_number: `${block_day?.day_number || ''}`.trim()
			}))
			.filter((block_day) => block_day.day_number);

		const block_data = {
			block_id: existing_block_info.block_id,
			course_id: existing_block_info.course_id,
			teacher_id: existing_block_info.teacher_id,
			classroom_id: existing_block_info.classroom_id,
			homeroom_teacher_id: existing_block_info.homeroom_teacher_id,
			start_time: existing_block_info.start_time,
			end_time: existing_block_info.end_time,
			is_lunch: `${existing_block_info.is_lunch || '0'}`,
			is_pullout: `${existing_block_info.is_pullout || '0'}`,
			is_special: `${existing_block_info.is_special || '0'}`,
			student_list: Array.isArray(existing_block_info.student_list) ? existing_block_info.student_list : [],
			locked_students: Array.isArray(existing_block_info.locked_students) ? existing_block_info.locked_students : [],
			secondary_teachers: Array.isArray(existing_block_info.secondary_teachers) ? existing_block_info.secondary_teachers : []
		};

		const data = {
			school_id,
			schedule_version_id,
			affected_blocks: normalized_block_days,
			removed_blocks: [],
			block_data
		};
		const apiName = process.env.REACT_APP_ELEM_ENDPOINT_NAME;
		const url = '/elementary/save-block';
		const myInit = {
			response: true,
			body: JSON.stringify(data),
		};

		try
		{
			await API.post(apiName, url, myInit);
			return true;
		}
		catch(error)
		{
			console.log(error?.response || error);
			return false;
		}
	};

	const resetBoardDraftState = () => {
		setCardPlacements({});
		setPersistedPlannerBlockIDs({});
		setUnassignedPlannerCardIDs({});
		setMovedExistingPlacements({});
		setUnassignedExistingIDs({});
		setPendingPlacementCellKey(null);
		setPendingRemovalItemKey(null);
		setDraggingCardID(null);
		setDraggingExistingID(null);
		setActiveDropCellKey(null);
	};

	const refreshExistingBlocksFromBackend = async ({ resetPlannerState = false } = {}) => {
		const refreshed_blocks = await getData('blocks', '/elementary/get-blocks', {school_id, schedule_version_id}, true, 'elementary');
		setBlocks(refreshed_blocks);
		if(resetPlannerState) resetBoardDraftState();
		else
		{
			setMovedExistingPlacements({});
			setUnassignedExistingIDs({});
		}
	};

	const saveBlockPlacementToBackend = async ({ block_id = null, course_id = null, homeroom_teacher_id = null, specials_teacher_id = null, day_number = null, period_row_id = null, existing_block_info = null }) => {
		if(!school_id || !schedule_version_id) return {success:false, saved_block_id:null};

		const normalized_day_number = `${day_number || ''}`.trim();
		const normalized_specials_teacher_id = `${specials_teacher_id || ''}`.trim();
		const normalized_course_id = `${course_id || ''}`.trim();
		const period_info = period_by_row_id_map.get(`${period_row_id}`);
		const start_time = period_info?.start_time || existing_block_info?.start_time || null;
		const end_time = period_info?.end_time || existing_block_info?.end_time || null;
		if(!normalized_day_number || !normalized_specials_teacher_id || !normalized_course_id || !start_time || !end_time) return {success:false, saved_block_id:null};

		if(existing_block_info?.block_id && Array.isArray(existing_block_info.block_days) && existing_block_info.block_days.length > 1)
		{
			const kept_block_days = existing_block_info.block_days.filter((block_day) => `${block_day?.day_number || ''}` !== normalized_day_number);
			const split_success = await syncExistingBlockDaysToBackend(existing_block_info, kept_block_days);
			if(!split_success) return {success:false, saved_block_id:null};
			block_id = null;
		}

		const temp_block_id = `${block_id || `planner-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`}`;
		const block_data = {
			block_id: temp_block_id,
			block_day_id: existing_block_info?.block_day_id || null,
			course_id: normalized_course_id,
			teacher_id: normalized_specials_teacher_id,
			classroom_id: existing_block_info?.classroom_id || null,
			homeroom_teacher_id: `${homeroom_teacher_id || existing_block_info?.homeroom_teacher_id || ''}` || null,
			start_time,
			end_time,
			day_number: normalized_day_number,
			days: [normalized_day_number],
			block_days: [{block_day_id:existing_block_info?.block_day_id || null, day_number:normalized_day_number}],
			is_lunch: `${existing_block_info?.is_lunch || '0'}`,
			is_pullout: `${existing_block_info?.is_pullout || '0'}`,
			is_special: `${existing_block_info?.is_special || '1'}`,
			student_list: (Array.isArray(existing_block_info?.student_list)) ? existing_block_info.student_list : [],
			locked_students: (Array.isArray(existing_block_info?.locked_students)) ? existing_block_info.locked_students : [],
			secondary_teachers: (Array.isArray(existing_block_info?.secondary_teachers)) ? existing_block_info.secondary_teachers : []
		};

		const data = {
			school_id,
			schedule_version_id,
			affected_blocks: [{block_id: temp_block_id, block_day_id:existing_block_info?.block_day_id || null, day_number: normalized_day_number}],
			removed_blocks: [],
			block_data
		};

		const apiName = process.env.REACT_APP_ELEM_ENDPOINT_NAME;
		const url = '/elementary/save-block';
		const myInit = {
			response: true,
			body: JSON.stringify(data),
		};

		try
		{
			const response = await API.post(apiName, url, myInit);
			const new_block_ids = (Array.isArray(response?.data?.new_block_ids)) ? response.data.new_block_ids : [];
			const matched_block_id = new_block_ids.find((new_block_combo) => `${new_block_combo.old_block_id}` === temp_block_id);
			const saved_block_id = (matched_block_id) ? `${matched_block_id.new_block_id}` : temp_block_id;
			return {success:true, saved_block_id};
		}
		catch(error)
		{
			console.log(error?.response || error);
			return {success:false, saved_block_id:null};
		}
	};

	const deleteBlocksFromBackend = async (block_ids = []) => {
		if(!school_id || !schedule_version_id) return {success:false, deleted_block_ids:[]};

		const normalized_block_ids = [...new Set((Array.isArray(block_ids) ? block_ids : [])
			.map((block_id) => `${block_id || ''}`.trim())
			.filter(Boolean))];
		if(normalized_block_ids.length === 0) return {success:true, deleted_block_ids:[]};

		const data = {
			school_id,
			schedule_version_id,
			block_ids: normalized_block_ids
		};

		const apiName = process.env.REACT_APP_ELEM_ENDPOINT_NAME;
		const url = '/elementary/delete-block';
		const myInit = {
			response: true,
			body: JSON.stringify(data),
		};

		try
		{
			const response = await API.post(apiName, url, myInit);
			const deleted_block_ids = (Array.isArray(response?.data?.deleted_block_ids) ? response.data.deleted_block_ids : normalized_block_ids)
				.map((block_id) => `${block_id || ''}`.trim())
				.filter(Boolean);
			return {success:true, deleted_block_ids};
		}
		catch(error)
		{
			console.log(error?.response || error);
			return {success:false, deleted_block_ids:[]};
		}
	};

	const deleteBlockFromBackend = async (block_id) => {
		const normalized_block_id = `${block_id || ''}`.trim();
		if(!normalized_block_id) return false;
		const delete_results = await deleteBlocksFromBackend([normalized_block_id]);
		return delete_results.success && delete_results.deleted_block_ids.includes(normalized_block_id);
	};

	const handleClearAllSpecialsFromBoard = async () => {
		if(isClearingAllSpecials) return;
		setGridActionsVisible(false);
		const options = {
			title: 'Are you sure?',
			icon: 'warning',
			dangerMode: true,
			buttons: {
				cancel: {
					text: 'Cancel',
					value: false,
					visible: true,
					className: 'gray-btn'
				},
				confirm: {
					text: 'Yes, clear all',
					value: true,
					visible: true,
					className: 'red-btn'
				},
			},
			content: (
				<div>
					<p>This will remove all currently placed specials from the board.</p>
				</div>
			)
		};

		const confirmed = await swal(options);
		if(!confirmed) return;

		setIsClearingAllSpecials(true);
		resetClearAllProgress();
		try
		{
			await updateClearAllProgress({
				percent: 8,
				phase_label: 'Preparing',
				status_line: 'Collecting currently placed specials...'
			});

			const special_existing_items = Object.values(existing_block_item_map).filter((existing_item) => {
				const block_id = `${existing_item?.block_id || ''}`.trim();
				if(!block_id) return false;
				const block_info = block_by_id_map.get(block_id);
				return isSpecialNonLunchBlock(block_info);
			});

			const persisted_planner_entries = Object.entries(persistedPlannerBlockIDs).filter(([, block_id]) => `${block_id || ''}`.trim() !== '');
			const block_ids_to_delete = new Set();

			special_existing_items.forEach((existing_item) => {
				const block_id = `${existing_item?.block_id || ''}`.trim();
				if(block_id) block_ids_to_delete.add(block_id);
			});
			persisted_planner_entries.forEach(([, block_id]) => {
				const normalized_block_id = `${block_id || ''}`.trim();
				if(normalized_block_id) block_ids_to_delete.add(normalized_block_id);
			});

			await updateClearAllProgress({
				percent: 24,
				phase_label: 'Deleting',
				status_line: `Deleting ${block_ids_to_delete.size} placed specials from the board...`
			});

			await updateClearAllProgress({
				percent: 58,
				phase_label: 'Deleting',
				status_line: 'Sending bulk delete request...'
			});

			const delete_results = await deleteBlocksFromBackend([...block_ids_to_delete]);
			const deleted_block_ids = new Set(delete_results.deleted_block_ids || []);
			const failed_block_ids = new Set([...block_ids_to_delete].filter((block_id) => !deleted_block_ids.has(block_id)));
			const planner_card_ids_to_clear = new Set();

			Object.keys(cardPlacements).forEach((card_id) => {
				const persisted_block_id = `${persistedPlannerBlockIDs[card_id] || ''}`.trim();
				if(!persisted_block_id || !failed_block_ids.has(persisted_block_id)) planner_card_ids_to_clear.add(card_id);
			});

			const existing_instance_ids_to_clear = new Set();
			Object.values(existing_block_item_map).forEach((existing_item) => {
				const existing_instance_id = `${existing_item?.existing_instance_id || ''}`.trim();
				const block_id = `${existing_item?.block_id || ''}`.trim();
				if(!existing_instance_id || !block_id || !deleted_block_ids.has(block_id)) return;
				existing_instance_ids_to_clear.add(existing_instance_id);
			});

			setCardPlacements((previous_placements) => {
				const next_placements = {...previous_placements};
				planner_card_ids_to_clear.forEach((card_id) => {
					delete next_placements[card_id];
				});
				return next_placements;
			});

			setPersistedPlannerBlockIDs((previous_map) => {
				const next_map = {...previous_map};
				Object.keys(next_map).forEach((card_id) => {
					const persisted_block_id = `${next_map[card_id] || ''}`.trim();
					if(!persisted_block_id || deleted_block_ids.has(persisted_block_id)) delete next_map[card_id];
				});
				return next_map;
			});

			setUnassignedPlannerCardIDs((previous_ids) => {
				const next_ids = {...previous_ids};
				planner_card_ids_to_clear.forEach((card_id) => {
					delete next_ids[card_id];
				});
				return next_ids;
			});

			setMovedExistingPlacements((previous_placements) => {
				const next_placements = {...previous_placements};
				existing_instance_ids_to_clear.forEach((existing_instance_id) => {
					delete next_placements[existing_instance_id];
				});
				return next_placements;
			});

			setUnassignedExistingIDs((previous_ids) => {
				const next_ids = {...previous_ids};
				existing_instance_ids_to_clear.forEach((existing_instance_id) => {
					next_ids[existing_instance_id] = true;
				});
				return next_ids;
			});

			setDraggingCardID(null);
			setDraggingExistingID(null);
			setActiveDropCellKey(null);

			await updateClearAllProgress({
				percent: 100,
				phase_label: 'Complete',
				status_line: 'Board cleared and unassigned lists updated.',
				delay_ms: 120
			});
		}
		finally
		{
			resetClearAllProgress();
			setIsClearingAllSpecials(false);
		}
	};

	const handleCardDragStart = (card_id, event) => {
		const card_info = planner_card_map.get(card_id);
		if(card_info)
		{
			const multi_count_display = (card_info.total_instances > 1) ? ` (${card_info.instance_index}/${card_info.total_instances})` : '';
			setLargeDragPreview(event, `${card_info.course_name}${multi_count_display}`, card_info.homeroom_teacher_name, card_info.tag_color);
		}
		draggingPayloadRef.current = {type:'planner', id:card_id};
		setDraggingCardID(card_id);
		setDraggingExistingID(null);
		if(event?.dataTransfer)
		{
			event.dataTransfer.effectAllowed = 'move';
			event.dataTransfer.setData('text/plain', `planner:${card_id}`);
		}
	};

	const handleExistingBlockDragStart = (existing_instance_id, event) => {
		if(!existing_instance_id) return;
		const existing_item = existing_block_item_map[existing_instance_id];
		if(existing_item) setLargeDragPreview(event, existing_item.label, existing_item.homeroom_teacher_name, existing_item.tag_color);
		draggingPayloadRef.current = {type:'existing', id:existing_instance_id};
		setDraggingExistingID(existing_instance_id);
		setDraggingCardID(null);
		if(event?.dataTransfer)
		{
			event.dataTransfer.effectAllowed = 'move';
			event.dataTransfer.setData('text/plain', `existing:${existing_instance_id}`);
		}
	};

	const handleCardDragEnd = () => {
		draggingPayloadRef.current = {type:null, id:null};
		setDraggingCardID(null);
		setDraggingExistingID(null);
		setActiveDropCellKey(null);
	};

	const handleCellDragOver = (cell_key, event) => {
		event.preventDefault();
		event.dataTransfer.dropEffect = 'move';
		if(activeDropCellKey !== cell_key) setActiveDropCellKey(cell_key);
	};

	const handleCellDrop = async (period_row_id, day_number, specials_teacher_id, event) => {
		event.preventDefault();
		const dropped_data = event.dataTransfer.getData('text/plain') || '';
		const dropped_data_parts = dropped_data.split(':');
		const dropped_type = (dropped_data_parts.length > 1) ? dropped_data_parts[0] : null;
		const dropped_id = (dropped_data_parts.length > 1) ? dropped_data_parts.slice(1).join(':') : dropped_data;

		let resolved_type = null;
		let resolved_id = null;

		if((dropped_type === 'planner' || dropped_type === 'existing') && dropped_id)
		{
			resolved_type = dropped_type;
			resolved_id = dropped_id;
		}
		else if(draggingCardID || (draggingPayloadRef.current.type === 'planner' && draggingPayloadRef.current.id))
		{
			resolved_type = 'planner';
			resolved_id = draggingCardID || draggingPayloadRef.current.id;
		}
		else if(draggingExistingID || (draggingPayloadRef.current.type === 'existing' && draggingPayloadRef.current.id))
		{
			resolved_type = 'existing';
			resolved_id = draggingExistingID || draggingPayloadRef.current.id;
		}

		if(!resolved_type || !resolved_id) return;
		const target_cell_key = `${period_row_id}__${day_number}__${specials_teacher_id}`;
		setPendingPlacementCellKey(target_cell_key);

		try
		{
			if(resolved_type === 'planner')
			{
				const card_info = planner_card_map.get(resolved_id);
				if(!card_info) return;
				const existing_block_id = persistedPlannerBlockIDs[resolved_id] || null;
				const save_result = await saveBlockPlacementToBackend({
					block_id: existing_block_id,
					course_id: card_info.course_id,
					homeroom_teacher_id: card_info.homeroom_teacher_id,
					specials_teacher_id,
					day_number,
					period_row_id
				});
				if(!save_result.success) return;

				if(save_result.saved_block_id)
				{
					setPersistedPlannerBlockIDs((previous_map) => ({
						...previous_map,
						[resolved_id]: save_result.saved_block_id
					}));
				}

				setCardPlacements((previous_placements) => ({
					...previous_placements,
					[resolved_id]: {
						period_row_id: `${period_row_id}`,
						day_number: `${day_number}`,
						specials_teacher_id: `${specials_teacher_id}`
					}
				}));
				setUnassignedPlannerCardIDs((previous_ids) => {
					if(!(resolved_id in previous_ids)) return previous_ids;
					const next_ids = {...previous_ids};
					delete next_ids[resolved_id];
					return next_ids;
				});
			}
			else if(resolved_type === 'existing')
			{
				const existing_item = existing_block_item_map[resolved_id];
				if(!existing_item) return;
				const existing_block_info = block_by_id_map.get(`${existing_item.block_id || ''}`) || null;
				const save_result = await saveBlockPlacementToBackend({
					block_id: existing_item.block_id,
					course_id: existing_item.course_id,
					homeroom_teacher_id: existing_item.homeroom_teacher_id,
					specials_teacher_id,
					day_number,
					period_row_id,
					existing_block_info
				});
				if(!save_result.success) return;

				await refreshExistingBlocksFromBackend();
			}
		}
		finally
		{
			setPendingPlacementCellKey((previous_key) => previous_key === target_cell_key ? null : previous_key);
			setDraggingCardID(null);
			setDraggingExistingID(null);
			setActiveDropCellKey(null);
		}
	};

	const handleUnassignedDragOver = (event) => {
		event.preventDefault();
		event.dataTransfer.dropEffect = 'move';
		if(activeDropCellKey !== 'planner-unassigned') setActiveDropCellKey('planner-unassigned');
	};

	const handleUnassignedDrop = async (event) => {
		event.preventDefault();
		const dropped_data = event.dataTransfer.getData('text/plain') || '';
		const dropped_data_parts = dropped_data.split(':');
		const dropped_type = (dropped_data_parts.length > 1) ? dropped_data_parts[0] : null;
		const dropped_id = (dropped_data_parts.length > 1) ? dropped_data_parts.slice(1).join(':') : dropped_data;

		let resolved_type = null;
		let resolved_id = null;

		if((dropped_type === 'planner' || dropped_type === 'existing') && dropped_id)
		{
			resolved_type = dropped_type;
			resolved_id = dropped_id;
		}
		else if(draggingCardID || (draggingPayloadRef.current.type === 'planner' && draggingPayloadRef.current.id))
		{
			resolved_type = 'planner';
			resolved_id = draggingCardID || draggingPayloadRef.current.id;
		}
		else if(draggingExistingID || (draggingPayloadRef.current.type === 'existing' && draggingPayloadRef.current.id))
		{
			resolved_type = 'existing';
			resolved_id = draggingExistingID || draggingPayloadRef.current.id;
		}

		if(!resolved_type || !resolved_id) return;
		const pending_removal_key = `${resolved_type}:${resolved_id}`;
		setPendingRemovalItemKey(pending_removal_key);

		try
		{
			if(resolved_type === 'planner')
			{
				if(!planner_card_map.has(resolved_id)) return;
				const persisted_block_id = persistedPlannerBlockIDs[resolved_id];
				if(persisted_block_id)
				{
					const delete_success = await deleteBlockFromBackend(persisted_block_id);
					if(!delete_success) return;
					setPersistedPlannerBlockIDs((previous_map) => {
						if(!(resolved_id in previous_map)) return previous_map;
						const next_map = {...previous_map};
						delete next_map[resolved_id];
						return next_map;
					});
				}

				setCardPlacements((previous_placements) => {
					if(!(resolved_id in previous_placements)) return previous_placements;
					const next_placements = {...previous_placements};
					delete next_placements[resolved_id];
					return next_placements;
				});
				setUnassignedPlannerCardIDs((previous_ids) => ({
					...previous_ids,
					[resolved_id]: true
				}));
			}
			else if(resolved_type === 'existing')
			{
				const existing_item = existing_block_item_map[resolved_id];
				if(!existing_item) return;
				const existing_block_info = block_by_id_map.get(`${existing_item.block_id || ''}`) || null;
				if(!existing_block_info) return;

				if(Array.isArray(existing_block_info.block_days) && existing_block_info.block_days.length > 1)
				{
					const kept_block_days = existing_block_info.block_days.filter((block_day) => `${block_day?.day_number || ''}` !== `${existing_item.day_number || ''}`);
					const split_success = await syncExistingBlockDaysToBackend(existing_block_info, kept_block_days);
					if(!split_success) return;
				}
				else
				{
					const delete_success = await deleteBlockFromBackend(existing_item.block_id);
					if(!delete_success) return;
				}

				await refreshExistingBlocksFromBackend();
				setUnassignedExistingIDs((previous_ids) => ({
					...previous_ids,
					[resolved_id]: true
				}));
			}
		}
		finally
		{
			setPendingRemovalItemKey((previous_key) => previous_key === pending_removal_key ? null : previous_key);
			setDraggingCardID(null);
			setDraggingExistingID(null);
			setActiveDropCellKey(null);
		}
	};

	const updateTeacherTagColor = useCallback(async (teacher_id, tag_color) => {
		const normalized_teacher_id = `${teacher_id || ''}`.trim();
		if(!normalized_teacher_id) return;

		const normalized_tag_color = normalizeTeacherTagColorClass(tag_color);
		const previous_tag_color = teacher_tag_color_map.get(normalized_teacher_id) || DEFAULT_TEACHER_TAG_COLOR;
		if(previous_tag_color === normalized_tag_color) return;

		setTeachers((previous_teachers) => previous_teachers.map((teacher_info) => {
			if(`${teacher_info.teacher_id}` !== normalized_teacher_id) return teacher_info;
			return {...teacher_info, tag_color: normalized_tag_color};
		}));

		const school_id = schoolInfo?.school_id;
		const schedule_version_id = schoolInfo?.current_schedule_version_id || scheduleInfo?.schedule_version_id;
		if(!school_id || !schedule_version_id) return;

		const data = {
			school_id,
			schedule_version_id,
			teacher_id: normalized_teacher_id,
			tag_color: normalized_tag_color
		};
		const url = '/elementary/update-teacher-tag-color';
		const myInit = {
			response: true,
			body: data,
		};

		try
		{
			const api_names = [process.env.REACT_APP_ELEM_ENDPOINT_NAME, process.env.REACT_APP_ENDPOINT_NAME].filter(Boolean);
			if(api_names.length === 0) throw new Error('Missing API endpoint configuration');

			let response = null;
			let last_error = null;
			for(let i = 0; i < api_names.length; i++)
			{
				const api_name = api_names[i];
				try
				{
					response = await API.post(api_name, url, myInit);
					last_error = null;
					break;
				}
				catch(error)
				{
					last_error = error;
				}
			}

			if(last_error) throw last_error;
			const saved_tag_color = normalizeTeacherTagColorClass(response?.data?.tag_color || normalized_tag_color);
			setTeachers((previous_teachers) => previous_teachers.map((teacher_info) => {
				if(`${teacher_info.teacher_id}` !== normalized_teacher_id) return teacher_info;
				return {...teacher_info, tag_color: saved_tag_color};
			}));
		}
		catch(error)
		{
			setTeachers((previous_teachers) => previous_teachers.map((teacher_info) => {
				if(`${teacher_info.teacher_id}` !== normalized_teacher_id) return teacher_info;
				return {...teacher_info, tag_color: previous_tag_color};
			}));
			console.log(error?.response || error);
		}
	}, [setTeachers, schoolInfo, scheduleInfo, teacher_tag_color_map]);

	useEffect(() => {
		const school_id = schoolInfo?.school_id;
		const schedule_version_id = schoolInfo?.current_schedule_version_id || scheduleInfo?.schedule_version_id;
		if(!school_id || !schedule_version_id || isLoading) return;
		if(auto_assign_colors_in_progress_ref.current) return;
		if(homeroom_teacher_ids_needing_any_special.length === 0) return;

		const available_colors = TEACHER_TAG_COLOR_OPTIONS.map(option => option.value);
		if(available_colors.length === 0) return;

		const teacher_ids_for_color_assignment = homeroom_teacher_ids_needing_any_special.filter((teacher_id) => teacher_tag_color_map.has(teacher_id));
		if(teacher_ids_for_color_assignment.length === 0) return;

		const used_colors = new Set();
		const updates = [];

		teacher_ids_for_color_assignment.forEach((teacher_id) => {
			const current_color = normalizeTeacherTagColorClass(teacher_tag_color_map.get(teacher_id) || DEFAULT_TEACHER_TAG_COLOR);
			let next_color = current_color;
			const keep_current_color = available_colors.includes(current_color) && !used_colors.has(current_color);

			if(!keep_current_color) next_color = available_colors.find(color => !used_colors.has(color)) || current_color;
			used_colors.add(next_color);
			if(next_color !== current_color) updates.push({teacher_id, tag_color: next_color});
		});

		if(updates.length === 0) return;

		(async () => {
			auto_assign_colors_in_progress_ref.current = true;
			try
			{
				for(const color_update of updates)
				{
					await updateTeacherTagColor(color_update.teacher_id, color_update.tag_color);
				}
			}
			finally
			{
				auto_assign_colors_in_progress_ref.current = false;
			}
		})();
	}, [isLoading, schoolInfo, scheduleInfo, homeroom_teacher_ids_needing_any_special, teacher_tag_color_map, updateTeacherTagColor]);

	const is_anything_dragging = Boolean(draggingCardID || draggingExistingID);
	const planner_filters_active = selected_planner_filters.length > 0 || Boolean(selectedPlannerGradeFilter) || hideCompletedTeachers;
	const selected_grid_homeroom_teacher_id_set = useMemo(() => {
		return new Set((selectedGridHomeroomTeacherIDs || []).map((teacher_id) => `${teacher_id || ''}`.trim()).filter(Boolean));
	}, [selectedGridHomeroomTeacherIDs]);

	useEffect(() => {
		const valid_teacher_ids = new Set(placed_grid_homeroom_teacher_ids.map((teacher_id) => `${teacher_id || ''}`.trim()).filter(Boolean));
		setSelectedGridHomeroomTeacherIDs((previous_ids) => previous_ids.filter((teacher_id) => valid_teacher_ids.has(`${teacher_id || ''}`.trim())));
	}, [placed_grid_homeroom_teacher_ids]);

	useEffect(() => {
		if(placed_grid_homeroom_teacher_ids.length > 1) return;
		setGridHomeroomTeacherFilterVisible(false);
	}, [placed_grid_homeroom_teacher_ids]);

	const selected_grid_specials_teacher_filters = useMemo(() => {
		const teacher_display_map = new Map(grid_specials_teacher_filter_options.map((option) => [option.value, option.display]));
		return selectedGridSpecialsTeacherIDs.map((teacher_id) => {
			const normalized_teacher_id = `${teacher_id || ''}`.trim();
			return {
				type: 'specials',
				value: normalized_teacher_id,
				display: teacher_display_map.get(normalized_teacher_id) || `Teacher ${normalized_teacher_id}`
			};
		}).filter((option) => option.value);
	}, [selectedGridSpecialsTeacherIDs, grid_specials_teacher_filter_options]);

	const selected_grid_homeroom_teacher_filters = useMemo(() => {
		const teacher_display_map = new Map(grid_homeroom_teacher_filter_options.map((option) => [option.value, option.display]));
		return selectedGridHomeroomTeacherIDs.map((teacher_id) => {
			const normalized_teacher_id = `${teacher_id || ''}`.trim();
			return {
				type: 'homeroom',
				value: normalized_teacher_id,
				display: teacher_display_map.get(normalized_teacher_id) || `Teacher ${normalized_teacher_id}`
			};
		}).filter((option) => option.value);
	}, [selectedGridHomeroomTeacherIDs, grid_homeroom_teacher_filter_options]);

	const selected_grid_filters = [...selected_grid_specials_teacher_filters, ...selected_grid_homeroom_teacher_filters];
	const specials_teacher_filter_button_label = (selectedGridSpecialsTeacherIDs.length === 0) ? 'All Specials Teachers' : `${selectedGridSpecialsTeacherIDs.length} selected`;
	const homeroom_teacher_filter_button_label = (selectedGridHomeroomTeacherIDs.length === 0) ? 'All Homeroom Teachers' : `${selectedGridHomeroomTeacherIDs.length} selected`;
	const is_specials_review_calculating = showInitialCalculationSkeleton && !isLoading;
	const planner_teacher_count = useMemo(() => {
		return homeroom_requirements_by_grade.reduce((total, grade_group) => total + ((grade_group?.teachers || []).length), 0);
	}, [homeroom_requirements_by_grade]);
	const filtered_planner_teacher_count = useMemo(() => {
		return filtered_homeroom_requirements_by_grade.reduce((total, grade_group) => total + ((grade_group?.teachers || []).length), 0);
	}, [filtered_homeroom_requirements_by_grade]);
	const filtered_unplaced_card_count = useMemo(() => {
		return filtered_homeroom_requirements_by_grade.reduce((total, grade_group) => {
			return total + (grade_group?.teachers || []).reduce((teacher_total, teacher_info) => teacher_total + ((teacher_info?.unplaced_cards || []).length), 0);
		}, 0);
	}, [filtered_homeroom_requirements_by_grade]);
	const existing_cell_bucket_count = useMemo(() => Object.keys(existing_cell_blocks_lookup || {}).length, [existing_cell_blocks_lookup]);
	const placed_card_bucket_count = useMemo(() => Object.keys(placed_cards_lookup || {}).length, [placed_cards_lookup]);
	const initial_calculation_signature = useMemo(() => {
		return [
			school_id,
			schedule_version_id,
			period_rows.length,
			cycle_days.length,
			teacher_header_meta.length,
			planner_cards.length,
			planner_teacher_count,
			filtered_planner_teacher_count,
			filtered_unplaced_card_count,
			existing_cell_bucket_count,
			placed_card_bucket_count,
			Object.keys(cardPlacements).length,
			Object.keys(unassignedPlannerCardIDs).length,
			Object.keys(movedExistingPlacements).length,
			Object.keys(unassignedExistingIDs).length
		].join('|');
	}, [
		school_id,
		schedule_version_id,
		period_rows.length,
		cycle_days.length,
		teacher_header_meta.length,
		planner_cards.length,
		planner_teacher_count,
		filtered_planner_teacher_count,
		filtered_unplaced_card_count,
		existing_cell_bucket_count,
		placed_card_bucket_count,
		cardPlacements,
		unassignedPlannerCardIDs,
		movedExistingPlacements,
		unassignedExistingIDs
	]);

	useEffect(() => {
		if(isLoading)
		{
			initial_calculation_complete_ref.current = false;
			setShowInitialCalculationSkeleton(true);
			return;
		}

		if(initial_calculation_complete_ref.current) return;
		setShowInitialCalculationSkeleton(true);

		let cancelled = false;
		const timer = setTimeout(() => {
			if(cancelled) return;
			initial_calculation_complete_ref.current = true;
			setShowInitialCalculationSkeleton(false);
		}, 180);

		return () => {
			cancelled = true;
			clearTimeout(timer);
		};
	}, [isLoading, initial_calculation_signature]);

	useEffect(() => {
		if(!is_anything_dragging) return;
		setBlockQuickView(null);
		setRowQuickView(null);
	}, [is_anything_dragging]);

	const showBlockQuickView = (event, block_payload) => {
		if(!block_payload || is_anything_dragging) return;
		const position = getQuickViewPositionFromEvent(event);
		setRowQuickView(null);
		setBlockQuickView({
			...block_payload,
			left: position.left,
			top: position.top
		});
	};

	const moveBlockQuickView = (event) => {
		const position = getQuickViewPositionFromEvent(event);
		setBlockQuickView((previous_view) => {
			if(!previous_view) return previous_view;
			return {...previous_view, left:position.left, top:position.top};
		});
	};

	const hideBlockQuickView = () => {
		setBlockQuickView(null);
	};

	const showRowQuickView = (event, conflict_reasons = []) => {
		if(is_anything_dragging) return;
		if(!Array.isArray(conflict_reasons) || conflict_reasons.length === 0) return;
		if(event?.target?.closest?.('.specials-review-cell-block')) return;

		const position = getQuickViewPositionFromEvent(event);
		setBlockQuickView(null);
		setRowQuickView({
			left: position.left,
			top: position.top,
			conflict_reasons: conflict_reasons
		});
	};

	const moveRowQuickView = (event, conflict_reasons = []) => {
		if(event?.target?.closest?.('.specials-review-cell-block')) return;
		const position = getQuickViewPositionFromEvent(event);
		setRowQuickView((previous_view) => {
			if(!previous_view)
			{
				if(!Array.isArray(conflict_reasons) || conflict_reasons.length === 0) return previous_view;
				setBlockQuickView(null);
				return {left:position.left, top:position.top, conflict_reasons};
			}
			return {...previous_view, left:position.left, top:position.top};
		});
	};

	const hideRowQuickView = () => {
		setRowQuickView(null);
	};

	return (
		<>
		{(subscreenRestricted) ?
		(
			<div className='general-screen-message'>
				<FontAwesomeIcon className='dark-blue-text' style={{fontSize:'60px'}} icon={faLock}/>
				<h1>No Access</h1>
				<div>You do not have access to this screen</div>
			</div>
		) : (subscreenLocked) ?
		(
			<div className='general-screen-message'>
				<FontAwesomeIcon className='dark-blue-text' style={{fontSize:'60px'}} icon={faLock}/>
				<h1>Temporarily Locked</h1>
				<div>This screen is locked until all other prior steps are completed</div>
			</div>
		) : (isLoading) ?
		(
			<div className='center-text'>
				<img src={require('../../../images/balls.gif')} alt='Loading...' style={{height:'25px'}}/>
			</div>
		) :
		(
			<>
				<div className='mb-elem-container specials-review-container'>
					<h1 className='progress-main-header'>Place Specials</h1>
					<p className='progress-subheader elem-manage-homerooms-subheader'>Drag homeroom specials into the grid.</p>

					<div className={`specials-review-planner ${activeDropCellKey === 'planner-unassigned' ? 'specials-review-planner-unassign-active' : ''}`} onDragOver={handleUnassignedDragOver} onDrop={handleUnassignedDrop}>
						<div className='specials-review-planner-title-row'>
							<div className='specials-review-planner-title-with-filters'>
								<div className='specials-review-planner-title'>Homeroom Specials To Place</div>
								<div className='specials-review-planner-grade-dropdown-wrapper'>
									<Dropdown
										data={planner_grade_filter_options}
										currentValue={selectedPlannerGradeFilter}
										displayDefault='All Grades'
										handleChange={(new_value) => setSelectedPlannerGradeFilter(`${new_value || ''}`)}
										className='specials-review-planner-grade-dropdown dropdown-container-compact'
									/>
								</div>
							</div>
							<div className='specials-review-planner-controls'>
								<button type='button' className={`specials-review-hide-completed-btn ${hideCompletedTeachers ? 'specials-review-hide-completed-btn-active' : ''}`} onClick={() => setHideCompletedTeachers((previous) => !previous)}>
									<span className={`specials-review-hide-completed-check ${hideCompletedTeachers ? 'specials-review-hide-completed-check-active' : ''}`}>{hideCompletedTeachers ? '✓' : ''}</span>
									<span>Hide completed teachers</span>
								</button>
								<div className='specials-review-planner-filter-wrap' ref={planner_filter_ref}>
									<button type='button' className='specials-review-planner-filter-btn' onClick={() => setPlannerFilterVisible(!plannerFilterVisible)}>
										<FontAwesomeIcon icon={faSlidersH}/>
										<div>Filter</div>
									</button>
									{plannerFilterVisible &&
										<div className='list-filter-options-container click-restricted specials-review-planner-filter-dropdown'>
											<div className='small-text'>Filter by:</div>
											{['teachers', 'specials'].map((filter_title) => {
												const filter_options = plannerFilterOptions[filter_title] || [];
												const filter_options_open = plannerOpenFilterOptions.includes(filter_title);
												const filter_group_selected_count = filter_options.filter((filter_option) => filter_option.selected).length;

												return (
													<div key={filter_title}>
														<div className='list-filter-title-container' onClick={() => updatePlannerOpenFilters(filter_title, filter_options_open)}>
															<div className='list-filter-title-label'>
																{getPlannerFilterTitleDisplay(filter_title)}
																{filter_group_selected_count > 0 &&
																	<span className='list-filter-title-selected-indicator'>{filter_group_selected_count}</span>
																}
															</div>
															<FontAwesomeIcon className='small-text' icon={filter_options_open ? faChevronUp : faChevronDown}/>
														</div>
														{filter_options_open &&
															filter_options.map((filter_option, option_index) => (
																<div className='parent-div list-filter-option click-restricted' key={`${filter_title}-${filter_option.value}`} onClick={() => updatePlannerFilterOption(filter_title, option_index, !filter_option.selected)}>
																	<div className='list-filter-option-name click-restricted'>{filter_option.display}</div>
																	{filter_option.selected ? (
																		<FontAwesomeIcon className='fas-checkbox-checked click-restricted' icon={faCheckSquare}/>
																	) : (
																		<FontAwesomeIcon className='fas-checkbox-unchecked click-restricted' icon={faSquare}/>
																	)}
																</div>
															))
														}
													</div>
												);
											})}
										</div>
									}
								</div>
							</div>
						</div>
						{selected_planner_filters.length > 0 &&
							<div className='mb-selected-filters-bar specials-review-planner-selected-filters'>
								<div className='mb-selected-filters-text'>Filters:</div>
								{selected_planner_filters.map((filter_option) => (
									<div className='mb-selected-filters-filter-tag' key={`${filter_option.filter_title}-${filter_option.value}`}>
										<div className='mb-selected-filters-filter-tag-inner-container'>
											<div>{filter_option.display}</div>
											<FontAwesomeIcon
												className='dark-gray-link'
												icon={faTimes}
												onClick={() => {
													const option_index = (plannerFilterOptions[filter_option.filter_title] || []).findIndex(option => option.value === filter_option.value);
													if(option_index !== -1) updatePlannerFilterOption(filter_option.filter_title, option_index, false);
												}}
											/>
										</div>
									</div>
								))}
							</div>
						}
						{is_anything_dragging &&
							<div className={`specials-review-planner-unassign-overlay ${activeDropCellKey === 'planner-unassigned' ? 'specials-review-planner-unassign-overlay-active' : ''}`}>
								<div className='specials-review-planner-unassign-overlay-title'>Drop Here To Unassign</div>
								<div className='specials-review-planner-unassign-overlay-subtitle'>Drop any placed block anywhere in this panel to unassign it.</div>
							</div>
						}
						<div className={`specials-review-planner-groups-scroll ${is_specials_review_calculating ? 'specials-review-skeleton-host' : ''}`}>
							{is_specials_review_calculating &&
								<div className='specials-review-skeleton-overlay specials-review-skeleton-overlay-planner'>
									<div className='specials-review-skeleton-line specials-review-skeleton-line-title'></div>
									<div className='specials-review-skeleton-planner-grid'>
										{Array.from({length:6}).map((_, index) => (
											<div className='specials-review-skeleton-planner-card' key={`planner-skeleton-card-${index}`}>
												<div className='specials-review-skeleton-line specials-review-skeleton-line-short'></div>
												<div className='specials-review-skeleton-chip-row'>
													<div className='specials-review-skeleton-chip'></div>
													<div className='specials-review-skeleton-chip'></div>
													<div className='specials-review-skeleton-chip'></div>
												</div>
											</div>
										))}
									</div>
								</div>
							}
							<div className={is_specials_review_calculating ? 'specials-review-skeleton-underlay' : ''}>
								{homeroom_requirements_by_grade.length === 0 &&
									<div className='specials-review-planner-empty'>No homeroom special requirements found yet. Add homerooms to specials courses first.</div>
								}
								{homeroom_requirements_by_grade.length > 0 && all_homerooms_have_specials_placed &&
									<div className='specials-review-planner-success'>
										<FontAwesomeIcon className='specials-review-planner-success-icon' icon={faCheckCircle}/>
										<div className='specials-review-planner-success-text'>All homerooms have their specials placed!</div>
									</div>
								}
								{homeroom_requirements_by_grade.length > 0 && !all_homerooms_have_specials_placed && filtered_homeroom_requirements_by_grade.length === 0 &&
									<div className='specials-review-planner-empty'>{planner_filters_active ? 'No homeroom teachers matched the current filters.' : 'No homeroom teachers found.'}</div>
								}
								{!all_homerooms_have_specials_placed && filtered_homeroom_requirements_by_grade.map((grade_group) => {
									const grade_label = grade_group.grade_label;
									return (
										<div className='specials-review-planner-grade-group' key={`grade-group-${grade_label}`}>
											<div className='specials-review-planner-teacher-list'>
												{grade_group.teachers.map((teacher_info) => {
											const teacher_id = teacher_info.teacher_id;
											const teacher_name = teacher_info.teacher_name;
											const unplaced_cards = teacher_info.unplaced_cards || [];
											const teacher_tag_color = normalizeTeacherTagColorClass(teacher_info.tag_color || teacher_tag_color_map.get(`${teacher_id}`) || DEFAULT_TEACHER_TAG_COLOR);
											const teacher_grade_labels_display = getTeacherGradeLabelsDisplay(teacher_info, grade_label);
											const used_tag_colors_by_other_teachers = new Set();
											Object.keys(homeroom_teacher_tag_colors_in_use).forEach((temp_teacher_id) => {
												if(temp_teacher_id === `${teacher_id}`) return;
												const temp_tag_color = normalizeTeacherTagColorClass(homeroom_teacher_tag_colors_in_use[temp_teacher_id] || teacher_tag_color_map.get(temp_teacher_id) || DEFAULT_TEACHER_TAG_COLOR);
												used_tag_colors_by_other_teachers.add(temp_tag_color);
											});
											const teacher_tag_color_options = TEACHER_TAG_COLOR_OPTIONS.map((option) => {
												const option_value = option.value;
												const is_current = option_value === teacher_tag_color;
												const is_in_use_by_other = used_tag_colors_by_other_teachers.has(option_value);
												return {
													...option,
													disabled: !is_current && is_in_use_by_other
												};
											});

											return (
												<div className='specials-review-planner-teacher-card' key={`teacher-planner-${teacher_id}`}>
													<div className='specials-review-planner-teacher-name-row'>
														<div className='specials-review-teacher-inline-picker'>
															<LabelColorPicker
																colorClass={teacher_tag_color}
																options={teacher_tag_color_options}
																onChange={(new_color) => updateTeacherTagColor(teacher_id, new_color)}
															/>
														</div>
														<div className='specials-review-planner-teacher-name-block'>
															<div className='specials-review-planner-teacher-name'>{teacher_name}</div>
															{teacher_grade_labels_display &&
																<div className='specials-review-planner-teacher-grade'>{teacher_grade_labels_display}</div>
															}
														</div>
													</div>
													<div className='specials-review-planner-cards-list'>
														{unplaced_cards.length === 0 &&
															<div className='specials-review-planner-all-placed'>All cards placed</div>
														}
														{unplaced_cards.map((card_info) => {
															const card_tag_color = normalizeTeacherTagColorClass(card_info.tag_color || teacher_tag_color);
															const card_tint_style = getDraggableCardTintStyle(card_tag_color);
															if(card_info._card_type === 'existing')
															{
																const existing_instance_id = card_info.existing_instance_id;
																return (
																	<div className='specials-review-draggable-card specials-review-draggable-card-existing' style={card_tint_style} key={`source-existing-card-${existing_instance_id}`} draggable onDragStart={(event) => handleExistingBlockDragStart(existing_instance_id, event)} onDragEnd={handleCardDragEnd}>
																		<div className={`specials-review-draggable-card-handle ${card_tag_color}`}>
																			<FontAwesomeIcon className='specials-review-draggable-card-grip-icon' icon={faEllipsisV}/>
																		</div>
																		<div className='specials-review-draggable-card-body'>
																			<div className='specials-review-draggable-card-name'>{card_info.label}</div>
																		</div>
																	</div>
																);
															}

															const card_id = card_info.card_id;
															const course_name = card_info.course_name;
															const multi_count_display = (card_info.total_instances > 1) ? ` (${card_info.instance_index}/${card_info.total_instances})` : '';

															return (
																<div className='specials-review-draggable-card' style={card_tint_style} key={`source-card-${card_id}`} draggable onDragStart={(event) => handleCardDragStart(card_id, event)} onDragEnd={handleCardDragEnd}>
																	<div className={`specials-review-draggable-card-handle ${card_tag_color}`}>
																		<FontAwesomeIcon className='specials-review-draggable-card-grip-icon' icon={faEllipsisV}/>
																	</div>
																	<div className='specials-review-draggable-card-body'>
																		<div className='specials-review-draggable-card-name'>{course_name}{multi_count_display}</div>
																	</div>
																</div>
															);
														})}
													</div>
												</div>
											);
												})}
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</div>

					<div className='specials-review-grid-section'>
					<div className='specials-review-grid-toolbar'>
						<div className='specials-review-grid-actions-wrap' ref={grid_actions_ref}>
							<button type='button' className='specials-review-grid-action-btn' onClick={toggleGridActionsMenu} disabled={isClearingAllSpecials || isRunningAutoPlacer || is_specials_review_calculating}>
								<div>Actions</div>
								<FontAwesomeIcon icon={faChevronDown}/>
							</button>
							{gridActionsVisible &&
								<div className='list-filter-options-container click-restricted specials-review-grid-actions-dropdown'>
									<div className='specials-review-grid-action-option' onClick={handleClearAllSpecialsFromBoard}>
										<div className='specials-review-grid-action-option-title'>Clear All Specials</div>
										<div className='specials-review-grid-action-option-subtitle'>Removes all currently placed specials from the board.</div>
									</div>
									<div className='specials-review-grid-action-option' onClick={() => runAutoPlacerPlaceholder()}>
										<div className='specials-review-grid-action-option-title'>Run Auto Placer</div>
										<div className='specials-review-grid-action-option-subtitle'>Balances teacher loads across days while honoring restrictions.</div>
									</div>
								</div>
							}
						</div>

						<div className='specials-review-grid-filter-wrap' ref={grid_specials_teacher_filter_ref}>
							<button type='button' className='specials-review-grid-filter-btn' onClick={toggleGridSpecialsTeacherFilterMenu} disabled={is_specials_review_calculating}>
								<div>Specials Teacher: {specials_teacher_filter_button_label}</div>
								<FontAwesomeIcon icon={faChevronDown}/>
							</button>
							{gridSpecialsTeacherFilterVisible &&
								<div className='list-filter-options-container click-restricted specials-review-grid-filter-dropdown'>
									{grid_specials_teacher_filter_options.map((option_info) => {
										const option_selected = selectedGridSpecialsTeacherIDs.includes(option_info.value);
										return (
											<div className='parent-div list-filter-option click-restricted' key={`grid-specials-filter-${option_info.value}`} onClick={() => toggleGridSpecialsTeacherFilterValue(option_info.value)}>
												<div className='list-filter-option-name click-restricted'>{option_info.display}</div>
												<FontAwesomeIcon className={option_selected ? 'fas-checkbox-checked click-restricted' : 'fas-checkbox-unchecked click-restricted'} icon={option_selected ? faCheckSquare : faSquare}/>
											</div>
										);
									})}
								</div>
							}
						</div>

						{grid_homeroom_teacher_filter_options.length > 1 &&
							<div className='specials-review-grid-filter-wrap' ref={grid_homeroom_teacher_filter_ref}>
								<button type='button' className='specials-review-grid-filter-btn' onClick={toggleGridHomeroomTeacherFilterMenu} disabled={is_specials_review_calculating}>
									<div>Homeroom Teacher: {homeroom_teacher_filter_button_label}</div>
									<FontAwesomeIcon icon={faChevronDown}/>
								</button>
								{gridHomeroomTeacherFilterVisible &&
									<div className='list-filter-options-container click-restricted specials-review-grid-filter-dropdown'>
										{grid_homeroom_teacher_grouped_filter_options.map((option_info) => {
											if(option_info.option_is_group_label)
											{
												return (
													<div className='list-filter-title-container' key={`grid-homeroom-filter-group-${option_info.value}`}>
														<div>{option_info.display}</div>
													</div>
												);
											}

											const option_selected = selectedGridHomeroomTeacherIDs.includes(option_info.value);
											return (
												<div className='parent-div list-filter-option click-restricted' key={`grid-homeroom-filter-${option_info.value}`} onClick={() => toggleGridHomeroomTeacherFilterValue(option_info.value)}>
													<div className='list-filter-option-name click-restricted'>{option_info.display}</div>
													<FontAwesomeIcon className={option_selected ? 'fas-checkbox-checked click-restricted' : 'fas-checkbox-unchecked click-restricted'} icon={option_selected ? faCheckSquare : faSquare}/>
												</div>
											);
										})}
									</div>
								}
							</div>
						}
					</div>
					{selected_grid_filters.length > 0 &&
						<div className='mb-selected-filters-bar specials-review-grid-selected-filters'>
							<div className='mb-selected-filters-text'>Grid Filters:</div>
							{selected_grid_filters.map((filter_option) => (
								<div className='mb-selected-filters-filter-tag' key={`grid-filter-${filter_option.type}-${filter_option.value}`}>
									<div className='mb-selected-filters-filter-tag-inner-container'>
										<div>{filter_option.display}</div>
										<FontAwesomeIcon
											className='dark-gray-link'
											icon={faTimes}
											onClick={() => {
												if(filter_option.type === 'specials') toggleGridSpecialsTeacherFilterValue(filter_option.value);
												if(filter_option.type === 'homeroom') toggleGridHomeroomTeacherFilterValue(filter_option.value);
											}}
										/>
									</div>
								</div>
							))}
						</div>
					}
					<div className={`specials-review-grid-scroll ${is_specials_review_calculating ? 'specials-review-skeleton-host' : ''}`} onDragLeave={() => setActiveDropCellKey(null)}>
						{is_specials_review_calculating &&
							<div className='specials-review-skeleton-overlay specials-review-skeleton-overlay-grid'>
								<div className='specials-review-skeleton-grid-head'>
									{Array.from({length:7}).map((_, index) => (
										<div className='specials-review-skeleton-grid-head-cell' key={`grid-head-skeleton-${index}`}></div>
									))}
								</div>
								<div className='specials-review-skeleton-grid-body'>
									{Array.from({length:7}).map((_, row_index) => (
										<div className='specials-review-skeleton-grid-row' key={`grid-row-skeleton-${row_index}`}>
											{Array.from({length:10}).map((__, column_index) => (
												<div className='specials-review-skeleton-grid-cell' key={`grid-cell-skeleton-${row_index}-${column_index}`}></div>
											))}
										</div>
									))}
								</div>
							</div>
						}
						<table className={`specials-review-grid ${is_specials_review_calculating ? 'specials-review-skeleton-underlay' : ''}`}>
							<thead>
								<tr>
									<th className='specials-review-time-header' rowSpan={2}>
										<div className='specials-review-time-header-label'>Period</div>
										{teacher_header_meta.length > 0 &&
											<button type='button' className='specials-review-legend-help-btn specials-review-time-header-help-btn' onClick={toggleLegendVisibility} title='Open Teacher Legend' aria-label='Open Teacher Legend' ref={legend_help_button_ref}>?</button>
										}
										{teacher_header_meta.length > 0 && legendVisible &&
											<div className='specials-review-legend-popover' ref={legend_popover_ref} style={legendPopoverStyle}>
												<div className='specials-review-legend-popover-title'>Specials Teacher Legend</div>
												<div className='specials-review-legend'>
													{teacher_header_meta.map((teacher_meta) => {
														return (
															<div className='specials-review-legend-item' key={`legend-${teacher_meta.teacher_id}`}>
																<div className='specials-review-legend-code'>{teacher_meta.code}</div>
																<div className='specials-review-legend-name'>{teacher_meta.full_name}</div>
															</div>
														);
													})}
												</div>
											</div>
										}
									</th>
									{cycle_days.map((day_number, day_index) => (
										<th className={`specials-review-day-header ${day_index > 0 ? 'specials-review-day-start' : ''}`} colSpan={teacher_col_count_per_day} key={`day-header-${day_number}`}>
											<div className='specials-review-day-header-content'>
												<div>Day {day_number}</div>
											</div>
										</th>
									))}
								</tr>
								<tr>
									{cycle_days.map((day_number, day_index) => {
										if(visible_teacher_header_meta.length === 0)
										{
											return <th className={`specials-review-teacher-header-empty ${day_index > 0 ? 'specials-review-day-start' : ''}`} key={`empty-teacher-header-${day_number}`}>No Specials Teachers</th>;
										}

										return visible_teacher_header_meta.map((teacher_meta, teacher_index) => {
											const day_start_class = (day_index > 0 && teacher_index === 0) ? 'specials-review-day-start' : '';
											return <th className={`specials-review-teacher-header ${day_start_class}`} title={teacher_meta.full_name} key={`teacher-header-${day_number}-${teacher_meta.teacher_id}`}>{teacher_meta.code}</th>;
										});
									})}
								</tr>
							</thead>
							<tbody>
								{period_rows.length === 0 &&
									<tr>
										<td className='specials-review-empty-periods' colSpan={1 + (cycle_days.length * teacher_col_count_per_day)}>No periods are available yet. Add periods in Specials Periods to build this review.</td>
									</tr>
								}
								{period_rows.map((period) => {
									const period_name = period.period_name || 'Untitled Period';
									const period_row_id = `${period._specials_review_row_id || ''}`;
									const period_time_display = (period.start_time && period.end_time) ? `${formatPeriodTimeDisplay(period.start_time)} - ${formatPeriodTimeDisplay(period.end_time)}` : '';
									const row_conflict_reasons = homeroom_day_conflict_meta.row_reasons[period_row_id] || [];
									const row_has_conflict = row_conflict_reasons.length > 0;

									return (
										<tr key={period._specials_review_row_id} className={row_has_conflict ? 'specials-review-conflict-row' : ''} onMouseEnter={row_has_conflict ? (event) => showRowQuickView(event, row_conflict_reasons) : undefined} onMouseMove={row_has_conflict ? (event) => moveRowQuickView(event, row_conflict_reasons) : undefined} onMouseLeave={row_has_conflict ? hideRowQuickView : undefined}>
											<td className={`specials-review-period-cell ${row_has_conflict ? 'specials-review-row-conflict-cell' : ''}`}>
												<div className='specials-review-period-name'>{period_name}</div>
												{period_time_display &&
													<div className='specials-review-period-time'>{period_time_display}</div>
												}
											</td>
											{cycle_days.map((day_number, day_index) => {
												if(visible_teacher_header_meta.length === 0)
												{
													const period_days = (Array.isArray(period.days)) ? period.days.map(day => `${day}`) : [];
													const period_runs_this_day = period_days.includes(`${day_number}`);
													const row_day_key = `${period_row_id}__${day_number}`;
													const row_day_has_conflict = (homeroom_day_conflict_meta.row_day_reasons[row_day_key] || []).length > 0;
													return (
														<td className={`specials-review-cell ${period_runs_this_day ? '' : 'specials-review-cell-not-in-day'} ${day_index > 0 ? 'specials-review-day-start' : ''} ${row_day_has_conflict ? 'specials-review-row-conflict-cell' : ''}`} key={`empty-teacher-cell-${period._specials_review_row_id}-${day_number}`}>
															<div className='specials-review-cell-empty'>{period_runs_this_day ? '-' : ''}</div>
														</td>
													);
												}

													return visible_teacher_header_meta.map((teacher_meta, teacher_index) => {
														const teacher_id = teacher_meta.teacher_id;
														const key = `${period._specials_review_row_id}__${day_number}__${teacher_id}`;
														const existing_cell_blocks = existing_cell_blocks_lookup[key] || [];
														const placed_cards = placed_cards_lookup[key] || [];
														const period_days = (Array.isArray(period.days)) ? period.days.map(day => `${day}`) : [];
														const period_is_not_in_this_day = !period_days.includes(`${day_number}`);
														const total_cell_block_count = existing_cell_blocks.length + placed_cards.length;
														const cell_has_conflict = !period_is_not_in_this_day && total_cell_block_count > 1;
														const row_day_key = `${period_row_id}__${day_number}`;
														const row_day_has_conflict = (homeroom_day_conflict_meta.row_day_reasons[row_day_key] || []).length > 0;

													const dragging_card_info = (draggingCardID) ? planner_card_map.get(draggingCardID) : null;
													const dragging_existing_info = (draggingExistingID) ? existing_block_item_map[draggingExistingID] : null;
													const dragging_info = dragging_card_info || dragging_existing_info || null;
													const drop_allowed = isCardPlacementAllowed(dragging_info, day_number, period, teacher_id);
													const is_any_dragging = Boolean(dragging_info);
														const dragging_state_class = (dragging_info) ? (drop_allowed ? 'specials-review-drop-allowed' : 'specials-review-drop-disallowed') : '';
														const active_drop_class = (is_any_dragging && activeDropCellKey === key) ? 'specials-review-drop-target-active' : '';

														const day_start_class = (day_index > 0 && teacher_index === 0) ? 'specials-review-day-start' : '';
														const cell_showing_pending_loader = !period_is_not_in_this_day && pendingPlacementCellKey === key && existing_cell_blocks.length === 0 && placed_cards.length === 0;

														return (
															<td className={`specials-review-cell ${period_is_not_in_this_day ? 'specials-review-cell-not-in-day' : ''} ${dragging_state_class} ${active_drop_class} ${day_start_class} ${row_day_has_conflict ? 'specials-review-row-conflict-cell' : ''}`} key={`cell-${key}`} onDragOver={(event) => handleCellDragOver(key, event)} onDrop={(event) => handleCellDrop(period._specials_review_row_id, day_number, teacher_id, event)}>
															{cell_showing_pending_loader &&
																<div className='specials-review-cell-loading'>
																	<img src={require('../../../images/balls.gif')} alt='Saving special...' style={{height:'22px'}}/>
																</div>
															}

															{(!cell_showing_pending_loader && !period_is_not_in_this_day && (!existing_cell_blocks || existing_cell_blocks.length === 0) && placed_cards.length === 0) &&
																<div className='specials-review-cell-empty'>-</div>
															}

															{(!period_is_not_in_this_day && existing_cell_blocks && existing_cell_blocks.length > 0) &&
																	<div className='specials-review-cell-block-list'>
																			{existing_cell_blocks.map((cell_block) => {
																				const existing_instance_id = cell_block.existing_instance_id;
																				const is_pending_removal = pendingRemovalItemKey === `existing:${existing_instance_id}`;
																				const teacher_tag_color = normalizeTeacherTagColorClass(cell_block.tag_color || DEFAULT_TEACHER_TAG_COLOR);
																				const homeroom_teacher_id = `${cell_block.homeroom_teacher_id || ''}`.trim();
																				const homeroom_filter_mismatch = (selected_grid_homeroom_teacher_id_set.size > 0) && !selected_grid_homeroom_teacher_id_set.has(homeroom_teacher_id);
																				const teacher_restriction_met = isTeacherAllowedForCourse(cell_block.course_id, teacher_id);
																				const is_valid_placement = isCardPlacementAllowed(cell_block, day_number, period, teacher_id);
																				const show_invalid_day_period_state = !is_valid_placement && teacher_restriction_met;
																				const homeroom_day_key = `${day_number}__${homeroom_teacher_id}`;
																				const homeroom_day_conflict = homeroom_teacher_id && homeroom_day_conflict_meta.conflicting_day_homeroom_keys.has(homeroom_day_key);
																				const block_conflict_messages = [];
																				if(cell_has_conflict) block_conflict_messages.push('More than one special is assigned in this period/day/teacher slot.');
																				if(show_invalid_day_period_state) block_conflict_messages.push('This course has a day/period restriction for this placement.');
																				if(!teacher_restriction_met) block_conflict_messages.push('This specials teacher is not assigned to teach this course.');
																				if(homeroom_day_conflict) block_conflict_messages.push(`${cell_block.homeroom_teacher_name || 'This homeroom teacher'} has more than one special on Day ${day_number}.`);
																				return (
																					<div className={`specials-review-cell-block specials-review-cell-block-existing specials-review-cell-block-tag-color ${teacher_tag_color} ${show_invalid_day_period_state ? 'specials-review-cell-block-invalid' : ''} ${cell_has_conflict ? 'specials-review-cell-block-conflict' : ''} ${teacher_restriction_met ? '' : 'specials-review-cell-block-wrong-teacher'} ${homeroom_filter_mismatch ? 'specials-review-cell-block-muted' : ''} ${is_pending_removal ? 'specials-review-cell-block-removing' : ''}`} key={existing_instance_id || cell_block.block_id || 'block'} draggable={!is_pending_removal} onDragStart={(event) => handleExistingBlockDragStart(existing_instance_id, event)} onDragEnd={handleCardDragEnd} onMouseEnter={is_pending_removal ? undefined : (event) => showBlockQuickView(event, {course_name:cell_block.label || 'Untitled Course', homeroom_teacher_name:cell_block.homeroom_teacher_name || 'No Homeroom Teacher', tag_color:teacher_tag_color, conflict_messages:block_conflict_messages})} onMouseMove={is_pending_removal ? undefined : moveBlockQuickView} onMouseLeave={is_pending_removal ? undefined : hideBlockQuickView}>
																						{is_pending_removal ?
																							<div className='specials-review-cell-block-loader'>
																								<img src={require('../../../images/balls.gif')} alt='Removing special...' style={{height:'18px'}}/>
																							</div>
																						:
																							<>
																								<div className='specials-review-cell-block-name ellipsis' title={cell_block.label}>{cell_block.label_abbrev}</div>
																								<div className='specials-review-cell-block-homeroom ellipsis' title={cell_block.homeroom_teacher_name}>{cell_block.homeroom_teacher_abbrev}</div>
																							</>
																						}
																				</div>
																			);
																		})}
																</div>
															}

															{(!period_is_not_in_this_day && placed_cards.length > 0) &&
																<div className='specials-review-cell-block-list'>
																	{placed_cards.map((card_info) => {
																		const card_id = card_info.card_id;
																		const is_pending_removal = pendingRemovalItemKey === `planner:${card_id}`;
																		const is_valid_placement = isCardPlacementAllowed(card_info, day_number, period_by_row_id_map.get(period._specials_review_row_id), teacher_id);
																		const teacher_restriction_met = isTeacherAllowedForCourse(card_info.course_id, teacher_id);
																		const show_invalid_day_period_state = !is_valid_placement && teacher_restriction_met;
																		const multi_count_display = (card_info.total_instances > 1) ? ` (${card_info.instance_index}/${card_info.total_instances})` : '';
																		const teacher_tag_color = normalizeTeacherTagColorClass(card_info.tag_color || DEFAULT_TEACHER_TAG_COLOR);
																		const homeroom_teacher_id = `${card_info.homeroom_teacher_id || ''}`.trim();
																		const homeroom_filter_mismatch = (selected_grid_homeroom_teacher_id_set.size > 0) && !selected_grid_homeroom_teacher_id_set.has(homeroom_teacher_id);
																		const homeroom_day_key = `${day_number}__${homeroom_teacher_id}`;
																		const homeroom_day_conflict = homeroom_teacher_id && homeroom_day_conflict_meta.conflicting_day_homeroom_keys.has(homeroom_day_key);
																		const block_conflict_messages = [];
																		if(cell_has_conflict) block_conflict_messages.push('More than one special is assigned in this period/day/teacher slot.');
																		if(show_invalid_day_period_state) block_conflict_messages.push('This course has a day/period restriction for this placement.');
																		if(!teacher_restriction_met) block_conflict_messages.push('This specials teacher is not assigned to teach this course.');
																		if(homeroom_day_conflict) block_conflict_messages.push(`${card_info.homeroom_teacher_name || 'This homeroom teacher'} has more than one special on Day ${day_number}.`);

																			return (
																				<div className={`specials-review-cell-block specials-review-cell-block-draft specials-review-cell-block-tag-color ${teacher_tag_color} ${show_invalid_day_period_state ? 'specials-review-cell-block-invalid' : ''} ${cell_has_conflict ? 'specials-review-cell-block-conflict' : ''} ${teacher_restriction_met ? '' : 'specials-review-cell-block-wrong-teacher'} ${homeroom_filter_mismatch ? 'specials-review-cell-block-muted' : ''} ${is_pending_removal ? 'specials-review-cell-block-removing' : ''}`} key={`placed-card-${card_id}`} draggable={!is_pending_removal} onDragStart={(event) => handleCardDragStart(card_id, event)} onDragEnd={handleCardDragEnd} onMouseEnter={is_pending_removal ? undefined : (event) => showBlockQuickView(event, {course_name:`${card_info.course_name || 'Untitled Course'}${multi_count_display}`, homeroom_teacher_name:card_info.homeroom_teacher_name || 'No Homeroom Teacher', tag_color:teacher_tag_color, conflict_messages:block_conflict_messages})} onMouseMove={is_pending_removal ? undefined : moveBlockQuickView} onMouseLeave={is_pending_removal ? undefined : hideBlockQuickView}>
																					{is_pending_removal ?
																						<div className='specials-review-cell-block-loader'>
																							<img src={require('../../../images/balls.gif')} alt='Removing special...' style={{height:'18px'}}/>
																						</div>
																					:
																						<>
																							<div className='specials-review-cell-block-name ellipsis' title={card_info.course_name}>{card_info.course_abbrev}{multi_count_display}</div>
																							<div className='specials-review-cell-block-homeroom ellipsis' title={card_info.homeroom_teacher_name}>{card_info.homeroom_teacher_abbrev}</div>
																						</>
																					}
																				</div>
																			);
																		})}
																</div>
															}
														</td>
													);
												});
											})}
										</tr>
									);
								})}
								{period_rows.length > 0 &&
									<tr className='specials-review-total-row'>
										<td className='specials-review-total-label'>
											<div>Totals</div>
											<div style={{textTransform:'none', fontWeight:'400', fontSize:'10px'}}>per day</div>
										</td>
										{cycle_days.map((day_number, day_index) => {
											if(visible_teacher_header_meta.length === 0)
											{
												return (
													<td className={`specials-review-total-cell ${day_index > 0 ? 'specials-review-day-start' : ''}`} key={`total-empty-${day_number}`}>
														-
													</td>
												);
											}

											return visible_teacher_header_meta.map((teacher_meta, teacher_index) => {
												const teacher_id = `${teacher_meta.teacher_id || ''}`.trim();
												const day_start_class = (day_index > 0 && teacher_index === 0) ? 'specials-review-day-start' : '';
												const total_for_column = total_blocks_by_day_teacher[`${day_number}__${teacher_id}`] || 0;
												return <td className={`specials-review-total-cell ${day_start_class}`} key={`total-${day_number}-${teacher_id}`}>{total_for_column}</td>;
											});
										})}
									</tr>
								}
							</tbody>
						</table>
					</div>
					</div>
				</div>
				{clearAllProgress.visible &&
					<div className='specials-review-auto-placer-overlay'>
						<div className='specials-review-auto-placer-modal'>
							<div className='specials-review-auto-placer-title'>Clearing Specials Board</div>
							<div className='specials-review-auto-placer-phase'>{clearAllProgress.phase_label || 'Processing'}</div>
							<div className='specials-review-auto-placer-status'>{clearAllProgress.status_line || 'Removing placed specials...'}</div>
							<div className='specials-review-auto-placer-progress-track'>
								<div className='specials-review-auto-placer-progress-fill' style={{width:`${Math.max(0, Math.min(100, clearAllProgress.percent || 0))}%`}} />
							</div>
							<div className='specials-review-auto-placer-progress-meta'>{Math.round(clearAllProgress.percent || 0)}%</div>
						</div>
					</div>
				}
				{autoPlacerProgress.visible &&
					<div className='specials-review-auto-placer-overlay'>
						<div className='specials-review-auto-placer-modal'>
							<div className='specials-review-auto-placer-title'>Optimizing Specials Placement</div>
							<div className='specials-review-auto-placer-phase'>{autoPlacerProgress.phase_label || 'Optimization'}</div>
							<div className='specials-review-auto-placer-status'>{autoPlacerProgress.status_line || 'Running optimization steps...'}</div>
							<div className='specials-review-auto-placer-progress-track'>
								<div className='specials-review-auto-placer-progress-fill' style={{width:`${Math.max(0, Math.min(100, autoPlacerProgress.percent || 0))}%`}} />
							</div>
							<div className='specials-review-auto-placer-progress-meta'>{Math.round(autoPlacerProgress.percent || 0)}%</div>
							{Array.isArray(autoPlacerProgress.step_log) && autoPlacerProgress.step_log.length > 0 &&
								<div className='specials-review-auto-placer-step-log'>
									{autoPlacerProgress.step_log.map((step_message, step_index) => (
										<div className='specials-review-auto-placer-step' key={`auto-placer-step-${step_index}`}>
											<div className='specials-review-auto-placer-step-dot' />
											<div className='specials-review-auto-placer-step-text'>{step_message}</div>
										</div>
									))}
								</div>
							}
						</div>
					</div>
				}
				{blockQuickView &&
					<div className='specials-review-quickview' style={{left:blockQuickView.left, top:blockQuickView.top}}>
						<div className='specials-review-quickview-title'>Block Quick View</div>
						<div className='specials-review-quickview-field'>
							<div className='specials-review-quickview-label'>Homeroom</div>
							<div className='specials-review-quickview-value specials-review-quickview-homeroom'>
								<span className={`specials-review-quickview-tag-indicator ${normalizeTeacherTagColorClass(blockQuickView.tag_color || DEFAULT_TEACHER_TAG_COLOR)}`}></span>
								<span>{blockQuickView.homeroom_teacher_name || 'No Homeroom Teacher'}</span>
							</div>
						</div>
						<div className='specials-review-quickview-field'>
							<div className='specials-review-quickview-label'>Course</div>
							<div className='specials-review-quickview-value'>{blockQuickView.course_name || 'Untitled Course'}</div>
						</div>
						<div className='specials-review-quickview-field'>
							<div className='specials-review-quickview-label'>Conflicts</div>
							{Array.isArray(blockQuickView.conflict_messages) && blockQuickView.conflict_messages.length > 0 ?
								<div className='specials-review-quickview-conflict-list'>
									{blockQuickView.conflict_messages.map((message, message_index) => (
										<div className='specials-review-quickview-conflict-item' key={`block-quickview-conflict-${message_index}`}>
											<FontAwesomeIcon className='specials-review-quickview-conflict-icon' icon={faTriangleExclamation}/>
											<div>{message}</div>
										</div>
									))}
								</div>
							:
								<div className='specials-review-quickview-no-conflict'>No conflicts on this block.</div>
							}
						</div>
					</div>
				}
				{rowQuickView &&
					<div className='specials-review-quickview specials-review-row-quickview' style={{left:rowQuickView.left, top:rowQuickView.top}}>
						<div className='specials-review-quickview-title'>Row Conflict</div>
						<div className='specials-review-quickview-conflict-list'>
							{(rowQuickView.conflict_reasons || []).map((message, message_index) => (
								<div className='specials-review-quickview-conflict-item' key={`row-quickview-conflict-${message_index}`}>
									<FontAwesomeIcon className='specials-review-quickview-conflict-icon' icon={faTriangleExclamation}/>
									<div>{message}</div>
								</div>
							))}
						</div>
					</div>
				}

				<div className='fixed-bottom-save-container'>
					<Button classes={['btn', 'btn-extra-large', 'green-btn', 'align-right', 'move-to-next-screen-btn']} selected={false} text='Go to Next Step: Grade Blocks Setup' onClickFunction={handleMoveToNextScreen} />
				</div>
			</>
		)}
		</>
	);
}
